const ar = {
  appTitle: 'أنا البطل',
  appSubtitle: 'قصص علاجية للأطفال، يكون فيها طفلك هو البطل',

  // Zone 1 — Hero identity
  zone1Title: 'مَن بطل القصة؟',
  name: 'اسم الطفل',
  namePlaceholder: 'ليلى',
  age: 'عمره',
  agePlaceholder: '٥',
  genderFemale: 'بنت',
  genderMale: 'ولد',

  // Story language toggle (Fos7a vs local dialect)
  storyLanguageLabel: 'لغة القصة',
  storyLanguageFos7a: 'فصحى بسيطة',
  storyLanguageLahja: ' لهجة محلية',
  storyLanguageEnglish: 'إنجليزي',
  storyLanguageHelper: 'يمكنك اختيار القصة بالفصحى المبسّطة (للقراءة المدرسية) أو باللهجة الشامية الفلسطينية (كما تتحدّث الأم مع طفلها).',

  // Imagery type selector
  imageStyleLabel: 'نمط الرسومات',
  imageStyleHelper: 'اختر شكل رسومات القصة.',
  // The two mains, labeled the way the audience knows these looks from
  // social media: the cinematic 3D family-reel style reads as «ديزني», the 2D
  // cel-illustration style as «أنمي». Legacy cartoon/3d stay valid server-side
  // for existing stories but are no longer offered on the create form.
  imageStyleOptions: [
    { value: 'pixar', label: 'ديزني 3D' },
    { value: 'anime', label: 'أنمي' },
  ],

  // Story line selector
  storyLineLabel: 'نوع القصة',
  storyLineFears: 'قصة علاجية (مخاوف)',
  storyLineImaginary: 'قصة خيالية',
  storyLineHero: 'قصة بطولية',
  storyLineHelper: 'اختر نوع القصة. حالياً القصة العلاجية للمخاوف هي الجاهزة بالكامل.',

  // Zone 2 — Therapeutic core
  zone2Title: 'ما الذي يمرّ به؟',
  issue: 'احكِ لنا ما الذي يحدث مع طفلك',
  issuePlaceholder: 'مثلاً: ابنتي عمرها ٤ سنوات، كلما أخذتها إلى الروضة تبدأ بالبكاء وتتمسّك بي ولا تدعني أذهب...',
  issueHelper: 'كلما أخبرتنا أكثر، كانت القصة أقرب إلى طفلك 💛',
  whenHappens: 'متى يحدث هذا أكثر؟',
  whenHappensPlaceholder: 'وقت النوم، قبل المدرسة، عندما يكون بعيداً عني...',
  howBehaves: 'كيف يتصرّف عندما يحدث؟',
  howBehavesPlaceholder: 'يبكي، يصرخ، ينعزل وحده، يرفض الكلام...',
  smallGoal: 'لو ساعدته القصة في أمر صغير واحد، فماذا تتمنّى؟',
  smallGoalPlaceholder: 'أن يستطيع النوم وحده، أن يذهب إلى المدرسة دون بكاء...',
  smallGoalHelper: 'لا يلزم أن يكون هدفاً كبيراً — تكفي خطوة صغيرة ☺',

  // New therapeutic detail fields
  familyStructure: 'تركيبة العائلة',
  familyStructureSelectPlaceholder: 'اختر تركيبة العائلة',
  familyStructureOptions: [
    'أب وأم',
    'عائلة مع أطفال',
    'أم وحيدة',
    'أب وحيد',
    'عائلة ممتدّة (جدّ/جدّة معهم)',
    'أهل بالتبنّي أو الكفالة',
    'يعيش مع الأقارب',
    'أخرى',
  ],
  personalityTraits: 'صفات شخصية طفلك',
  personalityTraitOptions: [
    'نشيط',
    'فضولي',
    'ذكي',
    'اجتماعي',
    'خجول',
    'عنيد',
    'حسّاس',
    'هادئ',
    'مرح',
    'حنون',
    'مستقل',
    'دقيق',
  ],
  personalityTraitsAddCustom: 'أضف صفة غير موجودة بالقائمة…',
  personalityTraitsAddBtn: 'إضافة',

  // Zone 3 — Optional extras
  zone3Toggle: 'تفاصيل إضافية تجعل القصة أجمل ✨',
  interests: 'ماذا يحبّ طفلك؟',
  interestsPlaceholder: 'الديناصورات، الرسم، السيارات، القطط...',
  interestsHelper: 'ندمج اهتماماته في القصة ليشعر أنها له',
  environment: 'أين تعيشون؟',
  environmentPlaceholder: 'بيت مع حديقة، شقة في المدينة...',
  environmentHelper: 'تلميح خفيف لجوّ القصة',
  photos: 'صور لطفلك',
  photosHint: 'حتى ٥ صور — نستخدمها في الرسومات لاحقاً',
  referenceUrls: 'روابط صور مرجعية',
  referenceUrlsPlaceholder: 'https://i.imgur.com/abc.png, https://example.com/ref.jpg',
  referenceUrlsHelper: 'روابط لصور تكون مرجعاً للشخصية (افصل بينها بفاصلة). تعمل مع Midjourney و Seedream.',

  // CTA
  submitWithName: 'لنكتب قصة لـ ',
  submitGeneric: 'لنكتب القصة ✨',

  // Loader
  loading1: 'نخطّط لقصة مميزة…',
  loading2: 'نكتب القصة…',
  loading3: 'نراجع القصة…',
  loading4: 'نهذّب اللغة…',
  loading5: 'نرسم المشاهد…',

  // Other
  again: 'اقرأ قصة جديدة',
  errorTitle: 'حدث خطأ',

  // Book viewer
  nextPage: 'الصفحة التالية',
  prevPage: 'الصفحة السابقة',
  bookStateClosedFront: 'الكتاب مغلق · الغلاف الأمامي',
  bookStateOpen: 'الكتاب مفتوح · صفحتان متقابلتان',
  bookStateClosedBack: 'الكتاب مغلق · الغلاف الخلفي',
  downloadPdf: 'حمّل القصة PDF 📕',
  downloadingPdf: 'جاري التحضير…',

  // ── Storefront ──
  home: 'الرئيسية',
  shopAll: 'جميع القصص',
  navStories: 'القصص',
  navTherapy: 'قصص علاجية',
  navBirthday: 'قصص خيالية',
  navHeroes: 'قصص الأبطال',
  navMilestones: 'خطوات كبيرة',
  navBlog: 'المدوّنة',
  heroHeadline: 'قصص شخصية لأطفالك — يكون فيها طفلك البطل',
  heroSubline: 'نكتب ونرسم قصة فريدة بالذكاء الاصطناعي، مخصصة لطفلك بالكامل',
  featureHero: 'طفلك هو البطل',
  featureHeroDesc: 'قصة فريدة باسمه وعلى مقاسه',
  featureIllustrations: 'رسومات بالذكاء الاصطناعي',
  featureIllustrationsDesc: 'كل مشهد يُرسم خصيصاً لطفلك',
  featureTherapy: 'محتوى علاجي',
  featureTherapyDesc: 'تساعد طفلك على تخطّي تحدياته',
  sampleStories: 'أمثلة على قصصنا',
  sampleTherapy: 'سارة والكلب الودود',
  sampleTherapyDesc: 'قصة علاجية تساعد الطفل على التغلّب على خوفه من الكلاب',
  sampleBirthday: 'يوسف وزعامة كوكب الديناصوريات',
  sampleBirthdayDesc: 'قصة هدية عيد ميلاد — يوسف بطل مغامرة فضائية',
  sampleHeroes: 'عباءة الشجاعة السحرية',
  sampleHeroesDesc: 'قصة بطولة — آدم يكتشف قواه الخارقة',
  viewPdf: 'اقرأ القصة ←',
  featuredTemplates: 'الأكثر طلباً',
  browseCategories: 'تصفّح حسب التصنيف',
  viewAll: 'عرض الكل',
  createYourStory: 'اصنع قصتك',
  startCreating: 'ابدأ الآن',
  from: 'من',
  currency: ' ₪',
  ageBandLabel: 'الفئة العمرية',
  templateNotFound: 'القالب غير موجود',
  categoryNotFound: 'التصنيف غير موجود',
  previewFailed: 'تعذّر إنشاء قصتك. يرجى المحاولة مرة أخرى.',
  tryAgain: 'إعادة المحاولة',
  backToHome: 'الرئيسية',
  back: 'رجوع',
  noTemplatesInCategory: 'لا توجد قصص في هذا التصنيف حالياً',

  // Variant types
  softcover: 'غلاف ورقي',
  hardcover: 'غلاف سميك + PDF',
  digital: 'نسخة رقمية PDF',

  // Imagination topic picker
  topicOther: 'موضوع ثاني',
  topicOtherEmoji: '✏️',
  topicOtherPlaceholder: 'اكتب فكرة القصة التي تريدها… مثلاً: طفلي بطل خارق يطير فوق حيفا وينقذ أصحابه',
  topicRequired: 'اختر موضوع القصة أو اضغط «موضوع ثاني» واكتب فكرتك',
  // Toggle fields (الجنس) open with nothing selected, so the parent must answer
  // them; these two lines are the nudge and the blocking error.
  toggleChooseHint: 'لم يتم الاختيار بعد',
  toggleRequiredPrefix: 'يرجى اختيار:',
  freePreviewLimitTitle: 'لقد استخدمت معاينتك المجانية',
  freePreviewLimitBody: 'لإتمام قصتك، أكمل طلبها الآن. بعد الطلب تحصل على تعديلات إضافية لتنقيحها كما تريد، ويعمل فريقنا على إتقانها، ولن نطبعها ونرسلها إلا بعد أن تعتمد النسخة النهائية بنفسك.',
  freePreviewLimitOrderCta: 'اطلب قصتك الآن',
  freePreviewLimitContactPrefix: 'لأي استفسار،',
  freePreviewLimitContactLink: 'تواصل معنا عبر واتساب',
  topicChange: 'غيّر الموضوع',

  // Create page
  createTitle: 'خصّص قصتك',
  requiredField: 'مطلوب',
  generatePreview: 'اصنع المعاينة',
  generatingPreview: 'جاري التحضير…',
  addToCart: 'أضف للسلة',
  characterImageLabel: 'صورة شخصية البطل',
  characterImageHelp: 'ارفع صورة واحدة للبطل لتظهر بنفس الملامح في كل المشاهد.',
  referenceImagesLabel: 'صور مرجعية إضافية',
  referenceImagesHelp: 'يمكنك رفع حتى 10 صور (مكان، حيوان أليف، أبطال آخرين…) لتظهر في القصة.',
  referenceDescriptionPlaceholder: 'مثال: صديقه سامي / جدّه / قطته الرمادية',
  referenceDescriptionHelp: 'اكتب تحت كل صورة مَن أو ما هي — نستخدم هذا الوصف لإظهار الشخصية أو الغرض فقط في المشاهد المناسبة (ولن تُضاف شخصيات لم ترفع صورتها).',
  removeImage: 'إزالة',

  noPhotoTitle: 'لحظة! لم تُضِف صورة لطفلك',
  noPhotoMessage: 'حين يرى طفلك نفسه بطلاً للقصة، تصبح أقرب إلى قلبه وأكثر متعة وتأثيراً. لذلك ننصحك برفع صورة له. وإن كنت تفضّل عدم رفع صورة، يمكنك وصف شكله بالكلمات وسننشئ شخصية تشبهه.',
  noPhotoUploadLabel: 'ارفع صورته الآن',
  noPhotoOr: 'أو',
  noPhotoDescribeLabel: 'صِف شكله بالكلمات',
  noPhotoDescribePlaceholder: 'مثلاً: شعر أسود قصير ومجعّد، عيون بنية، بشرة قمحية، يرتدي قميصاً أزرق…',
  noPhotoDescribeHelp: 'كلما كان الوصف أدقّ، جاءت الشخصية أقرب إلى طفلك.',
  noPhotoContinue: 'متابعة',
  noPhotoContinueAnyway: 'المتابعة بدون صورة',
  noPhotoClose: 'إغلاق',

  heroRecapLabel: 'القصة لـ',
  heroRecapEdit: 'تعديل',
  ageUnitOne: 'سنة',
  ageUnitTwo: 'سنتان',
  ageUnitFew: 'سنوات',
  ageUnitMany: 'سنة',
  contactStepTitle: 'بقيت خطوة واحدة قبل معاينة قصتك',
  contactStepSubtitle: 'اترك لنا بياناتك لنرسل إليك المعاينة ونتواصل معك بخصوص قصتك.',
  contactNameLabel: 'الاسم الكامل',
  contactEmailLabel: 'البريد الإلكتروني',
  contactPhoneLabel: 'رقم الهاتف (واتساب)',
  contactPhoneHelper: 'سنتواصل معك عبر واتساب عند الحاجة.',
  contactContinue: 'تابِع إلى المعاينة',
  contactBack: 'رجوع',
  contactErrorRequired: 'يرجى تعبئة الاسم والبريد الإلكتروني ورقم الهاتف.',
  contactErrorEmail: 'البريد الإلكتروني غير صالح.',
  contactErrorPhone: 'رقم الهاتف غير صالح.',

  adminForCustomerToggle: 'إنشاء معاينة لعميل (طلب يدوي)',
  adminForCustomerOn: 'وضع العميل مُفعّل: ستُسجَّل بيانات العميل وسيُنشَأ طلب حقيقي يمكنك إدارته من لوحة الطلبات.',
  adminForCustomerOff: 'فعّل هذا الخيار لإنشاء المعاينة نيابةً عن عميل (مثلاً طلب عبر واتساب يُدفع خارج المنصّة).',
  adminCustomerStepTitle: 'بيانات العميل',
  adminCustomerStepSubtitle: 'أدخل اسم العميل وبريده ورقم هاتفه. سنُنشئ له حساباً وطلباً يمكنك تحديث حالته لاحقاً (مدفوع / بانتظار الدفع).',

  dropzonePrimary: 'اسحب الصور هنا أو اضغط للاختيار',
  dropzoneDropNow: 'أفلت الصور هنا',
  dropzoneHintSingle: 'صورة واحدة • PNG أو JPG',
  dropzoneHintMulti: 'حتى {n} صور • PNG أو JPG',

  photoGuideAlt: 'مثال يوضّح كيف تصوّر طفلك: صورة قريبة وواضحة للوجه، وصور يُفضَّل تجنّبها',
  photoGuideZoom: 'تكبير المثال',
  photoGuideClose: 'إغلاق',

  photoHelpTitle: 'قبل أن ترفع الصورة',
  photoHelpText: 'دقيقة واحدة تكفي ليصبح البطل أشبه ما يكون بطفلك. انظر إلى المثال، ثم ارفع الصورة من هنا مباشرة.',
  photoHelpUploadLabel: 'ارفع صورة طفلك',
  photoHelpDone: 'متابعة',
  photoHelpLater: 'سأرفعها لاحقاً',

  imageSectionTitle: 'صور القصة',
  imageTipsTrigger: 'كيف ترفع صورة جيدة؟',
  imageTipsTitle: 'نصائح لصورة مثالية',
  imageTipsClose: 'إغلاق',
  imageTipsItems: [
    'استخدم صورة واضحة ومضاءة جيداً، ويُفضّل بإضاءة طبيعية.',
    'اجعل وجه الطفل ظاهراً بالكامل وفي مواجهة الكاميرا.',
    'اختر صورة لشخص واحد فقط دون أشخاص آخرين في الخلفية.',
    'تجنّب النظارات الشمسية والقبعات والفلاتر التي تغيّر الملامح.',
    'كلما ارتفعت دقة الصورة، كانت النتيجة أدقّ وأجمل.',
    'يُفضّل أن تكون الخلفية بسيطة وغير مزدحمة.',
  ],

  // Preview page
  previewScene: 'مشهد',
  previewLockedScene: 'اشترِ القصة لفتح جميع المشاهد',
  previewLockedEditable: 'وبعد الشراء تعدّل الصور وتطلب تعديل النص، وتعتمد كل صفحة قبل أن نرسلها',
  continueToCheckout: 'احصل عليه الآن',
  previewFreeScene: 'مشهد مجاني',
  storyPreviewSubtitle: 'هذه معاينة لقصتك — اشترِ النسخة الكاملة لفتح كل المشاهد والرسومات',

  bookReadyTitle: 'كتاب طفلك جاهز! 🎉',
  bookReadySubtitle: 'تصفّح القصة كاملة، وحمّلها PDF لتقرأها في أي وقت.',
  bookReadyDownloadHint: 'النسخة الكاملة بجودة الطباعة — احفظها على جهازك وشاركها مع العائلة.',
  bookPreparingTitle: 'نجهّز باقي صفحات قصتك…',
  bookPreparingSubtitle: 'نكمّل رسم كل المشاهد الآن. تستغرق هذه الخطوة دقيقة أو اثنتين.',

  previewBannerTitle: 'أعجبتك بداية القصة؟',
  previewBannerText: 'افتح جميع المشاهد والرسومات واحصل على نسخة طفلك الكاملة.',
  previewRiskReversal: 'بعد الشراء يمكنك تبديل الصور وطلب تعديل النص، ولا نرسلها إلا بعد موافقتك على كل صفحة',

  previewAssuranceTitle: 'هذه نسخة أوّلية — ونحن نتكفّل بإتقانها',
  previewAssuranceLead: 'ما تراه الآن مسوّدة أنشأها الذكاء الاصطناعي خصيصاً لطفلك. وقبل أن تصل إليك، يمرّ كل كتاب على فريقنا:',
  previewAssuranceStep1: 'نقرأ القصة ونراجع نصّها لغوياً، ونصحّح أيّ خطأ.',
  previewAssuranceStep2: 'ندقّق الرسومات، ونعدّل أو نعيد رسم أيّ مشهد لا يرضينا.',
  previewAssuranceStep3: 'لا نعتمد الكتاب للطباعة أو التسليم إلا بعد أن يكتمل ويصبح جميلاً.',
  previewAssuranceFoot: 'فلا تقلق إن لاحظت تفصيلاً بسيطاً في هذه المعاينة — نحن نهتمّ بالتفاصيل نيابةً عنك.',

  // "Need a hand?" hesitation offer (unpaid preview → WhatsApp)
  previewHelpBadge: 'مساعدة مجّانية من فريقنا',
  previewHelpTitle: 'أتريد صوراً أكثر احترافية لكتاب طفلك؟',
  previewHelpText: 'ما تراه الآن مسوّدة أوّلية. أخبرنا كيف تتخيّل كتاب طفلك، وسنساعدك على جعل الصور احترافية وجاهزة للطباعة — خطوة بخطوة، وبلا أيّ التزام.',
  previewHelpBullet1: 'نرسل لك نماذج حقيقية من كتب طبعناها',
  previewHelpBullet2: 'نشرح لك كيف نُتقن الصور ونجهّزها للطباعة',
  previewHelpBullet3: 'نجيب عن كلّ سؤال يدور في ذهنك',
  previewHelpCta: 'تحدّث معنا على واتساب',
  previewHelpReassure: 'ردّ سريع • بلا التزام • مجّاناً',
  previewHelpDismiss: 'أتابع التصفّح الآن',
  previewHelpClose: 'إغلاق',
  previewHelpWaIntro: 'مرحباً 👋 أنشأتُ للتوّ معاينة كتاب لطفلي على «أنا البطل»، وأودّ أن تساعدوني لأجعل الصور احترافية وجاهزة للطباعة. هل يمكنكم أن ترسلوا لي بعض الأمثلة وتشرحوا لي آلية العمل؟',
  previewHelpWaBook: 'الكتاب: {book}',
  previewHelpWaChild: 'اسم الطفل: {name}',

  // Checkout
  checkoutTitle: 'إتمام الطلب',
  checkoutFullName: 'الاسم الشخصي',
  checkoutPhone: 'رقم الهاتف',
  checkoutCity: 'المدينة / القرية',
  checkoutNeighborhood: 'الحي / المنطقة',
  checkoutAddress: 'العنوان الكامل',
  checkoutLandmark: 'علامة مميزة / نقطة دالة',
  checkoutPostalCode: 'الرمز البريدي / ميكود',
  checkoutPostalCodeInvalid: 'الرجاء إدخال رمز بريدي صحيح (أرقام فقط)',
  checkoutOptional: 'اختياري',
  checkoutLandmarkPlaceholder: 'مثال: بجانب مسجد القرية، مقابل المدرسة الابتدائية',
  checkoutNeighborhoodPlaceholder: 'مثال: حي السهل',
  checkoutShippingHint: 'لمساعدة المندوب على الوصول، أضف الحي وعلامة مميزة قريبة من المنزل.',
  checkoutPay: 'ادفع الآن',
  checkoutProcessing: 'جاري التحويل للدفع...',
  checkoutOrderSummary: 'ملخص الطلب',

  // Checkout success
  paymentConfirming: 'جاري تأكيد الدفع',
  paymentConfirmingHint: 'لحظات ونرسلك إلى صفحة الطلب — لا تغلق هذه النافذة',
  paymentSuccess: 'تم الدفع بنجاح!',
  paymentSuccessDesc: 'شكراً لك — طلبك قيد التجهيز',
  paymentPending: 'الدفع قيد المراجعة — سنرسل لك تأكيداً بالبريد',
  viewOrder: 'عرض الطلب',

  // Order detail
  orderTitle: 'تفاصيل الطلب',
  orderNumber: 'رقم الطلب',
  orderStatus: 'حالة الطلب',
  orderDate: 'التاريخ',
  orderShipping: 'عنوان التوصيل',
  orderShippingEdit: 'تعديل العنوان',
  orderShippingSave: 'حفظ العنوان',
  orderShippingSaving: 'جاري الحفظ…',
  orderShippingCancel: 'إلغاء',
  orderShippingLocked: 'لا يمكن تعديل العنوان بعد بدء الشحن.',
  orderShippingUpdated: 'تم تحديث عنوان التوصيل.',
  orderItems: 'المنتجات',
  orderBookTitle: 'الكتاب الكامل',
  orderBookHint: 'اعرض القصة كاملة بالصور وحمّلها بصيغة PDF.',
  orderBookView: 'اعرض الكتاب',
  orderBookLoading: 'جاري التحميل…',
  status_pending_payment: 'بانتظار الدفع',
  status_paid: 'مدفوع',
  status_in_production: 'قيد الإنتاج',
  status_shipped: 'تم الشحن',
  status_delivered: 'تم التوصيل',
  status_payment_failed: 'فشل الدفع',

  // Auth
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  logout: 'تسجيل الخروج',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  loginBtn: 'دخول',
  registerBtn: 'سجّل',
  noAccount: 'ليس لديك حساب؟',
  hasAccount: 'لديك حساب؟',
  myAccount: 'حسابي',
  myOrders: 'طلباتي',
  myStories: 'قصصي',

  autoLoginInProgress: 'جاري تسجيل الدخول…',
  magicLinkExpired: 'انتهت صلاحية رابط الدخول. الرجاء طلب رابط جديد.',
  forgotPassword: 'نسيت كلمة المرور؟',
  resetLinkSent: 'إذا كان بريدك مسجّلاً لدينا، أرسلنا لك رابط دخول. تفقّد بريدك الإلكتروني.',
  enterEmailFirst: 'أدخل بريدك الإلكتروني أولاً ثم اضغط "نسيت كلمة المرور؟".',

  // Finalize / approve
  finalizeBannerTitle: 'أنهِ المراجعة واعتمد الطباعة',
  finalizeBannerDesc: 'راجع قصتك كاملة، اطلب أي تعديلات، ثم اعتمدها لإرسالها للطباعة.',
  finalizeBannerCta: 'افتح صفحة المراجعة',
  finalizeApprovedTitle: 'تم اعتماد الطلب ✓',
  finalizeApprovedDesc: 'شكراً! قصتك في طريقها للطباعة.',
  finalizeApprovedOn: 'تاريخ الاعتماد',
  finalizePageTitle: 'راجع قصتك واعتمد الطباعة',
  finalizePageSubtitle: 'هذه نسختك الكاملة. تصفّحها، واطلب تعديلات إن لزم، ثم اضغط اعتماد.',
  finalizingImages: 'جاري إنشاء بقية الصور… قد يستغرق ذلك دقيقة إلى دقيقتين.',

  finalizeLoaderTitle: 'نُحضّر باقي رسومات قصتك ✨',
  finalizeLoaderSubtitle: 'بعد الدفع، نرسم باقي المشاهد بالأسلوب نفسه. عادةً يستغرق ذلك من دقيقة إلى دقيقتين — لا تغلق هذه الصفحة.',
  finalizeStage1: 'نُجهّز المراجع والشخصية…',
  finalizeStage2: 'نرسم باقي المشاهد…',
  finalizeStage3: 'لمسات أخيرة على القصة…',
  requestChangesLabel: 'اطلب تعديلات على القصة',
  requestChangesPlaceholder: 'اكتب التعديلات التي تريدها (سنضيف هذه الخاصية قريباً)…',
  approveAndPrint: 'اعتمد وأرسل للطباعة',
  approving: 'جاري الاعتماد…',
  backToOrder: 'العودة للطلب',

  // PDF → printed book upgrade
  upgradeBannerTitle: 'حوّل نسختك الرقمية إلى كتاب مطبوع',
  upgradeBannerDesc: 'ادفع الفرق فقط — نخصم ما دفعته للنسخة الرقمية من سعر الكتاب المطبوع.',
  upgradeBannerCta: 'الترقية إلى كتاب مطبوع',
  upgradePageTitle: 'الترقية إلى كتاب مطبوع',
  upgradePageSubtitle: 'اختر نوع الكتاب — نخصم ما دفعته سابقاً من السعر، وتدفع الفرق فقط.',
  upgradeBookPrice: 'سعر الكتاب',
  upgradeAlreadyPaid: 'المدفوع سابقاً (النسخة الرقمية)',
  upgradeRemaining: 'المتبقي للدفع',
  upgradePay: 'ادفع الفرق وأتمم الترقية',
  upgradeDoneTitle: 'تمت الترقية ✓',
  upgradeDoneDesc: 'تمت ترقية هذا الطلب إلى كتاب مطبوع.',
  upgradeDoneLink: 'عرض طلب الترقية',
  upgradeNotEligible: 'هذا الطلب غير قابل للترقية.',
  upgradeBadge: 'ترقية',

  // Admin approval
  adminColumnApproval: 'الاعتماد',
  adminApprovedBadge: 'معتمد ✓',
  adminColumnProduct: 'المنتج',
  pdfBadge: 'PDF',
  pdfIncludedTag: 'يشمل PDF',

  // Contact / Social
  contactWhatsApp: 'واتساب',

  // Cart
  cart: 'السلة',
  cartEmpty: 'السلة فارغة',
  cartPendingHint: 'هذه القصص بانتظار الدفع. أكمل الدفع في أي وقت لإتمام طلبك.',
  removeFromCart: 'إزالة',
  checkout: 'الدفع',
  completePayment: 'أكمل الدفع',
  completePaymentTitle: 'طلبك بانتظار الدفع',
  completePaymentDesc: 'لم يكتمل الدفع بعد. أكمل الدفع لإرسال قصتك إلى الإنتاج.',
  total: 'المجموع',
  subtotal: 'المجموع الفرعي',
  delivery: 'التوصيل',
  cartChangeVariant: 'تغيير النوع',
  cartVariantClose: 'إغلاق',
  cartVariantSaving: 'جارٍ الحفظ…',
  cartVariantLoadError: 'تعذّر تحميل الأنواع',
  cartVariantChangeError: 'تعذّر تغيير النوع',

  // Admin
  admin: 'لوحة التحكم',
  adminDashboard: 'لوحة التحكم',
  adminCategories: 'التصنيفات',
  adminTemplates: 'القوالب',
  adminOrders: 'الطلبات',
  adminUsers: 'المستخدمين',
  adminFeedback: 'التقييمات',
  adminSettings: 'الإعدادات',
  adminActions: 'إجراءات',
  adminMarkTest: 'وضع كاختبار',
  adminUnmarkTest: 'إلغاء الاختبار',
  adminDeleteOrder: 'حذف الطلب',
  adminConfirm: 'تأكيد',
  adminCancel: 'إلغاء',
  adminSave: 'حفظ',
  adminConfirmTitle: 'تأكيد الإجراء',
  adminConfirmDeleteOrder: 'سيُحذف هذا الطلب نهائياً ولا يمكن التراجع. هل تريد المتابعة؟',
  adminConfirmMarkTest: 'سيُعلَّم هذا الطلب كبيانات اختبار ويُخفى من الإحصائيات والقائمة الافتراضية. متابعة؟',
  adminConfirmUnmarkTest: 'ستُزال علامة الاختبار عن هذا الطلب وسيظهر ضمن الطلبات الفعلية. متابعة؟',
  adminAddOrder: 'إضافة طلب',
  adminAddOrderTitle: 'إضافة طلب يدوي',
  adminOrderName: 'اسم الزبون',
  adminOrderAmount: 'المبلغ المدفوع',
  adminProductType: 'المنتج',
  adminAddOrderNeedContact: 'أدخل الاسم أو البريد الإلكتروني على الأقل',

  // Admin Dashboard
  adminShowTestData: 'إظهار بيانات الاختبار',
  adminCreatePreviewForCustomer: 'إنشاء معاينة لعميل',
  adminBuildStoryManually: 'بناء قصة يدويًا',
  adminSeries: 'السلاسل',
  adminStatistics: 'الإحصائيات',
  adminAtcTitle: 'إضافات السلة',
  adminAtcHint: 'أي القصص تُضاف إلى سلة الدفع المسبق، بحسب مصدر الزائر: إعلانات preview=0، تجربة A/B، أو غير ذلك. تُستثنى الروبوتات.',
  adminAtcVariantUrl: 'إعلان (preview=0)',
  adminAtcVariantFlag: 'تجربة A/B',
  adminAtcVariantControl: 'أخرى',
  adminAtcVariantUnknown: 'غير معروف',
  adminAtcFunnelTitle: 'مسار الشراء — العدد (الزوّار)',
  adminAtcByStoryTitle: 'حسب القصة',
  adminAtcRecentTitle: 'آخر الإضافات',
  adminAtcNoData: 'لا توجد إضافات في هذه الفترة بعد.',
  adminAtcStep: 'الخطوة',
  adminAtcStepAtc: 'أُضيف إلى السلة',
  adminAtcStepCheckoutView: 'فتح صفحة الدفع',
  adminAtcStepCheckoutSubmit: 'أرسل الدفع',
  adminAtcStepCreated: 'أنشأ القصة بعد الدفع',
  adminAtcStory: 'القصة',
  adminAtcTotal: 'الإجمالي',
  adminAtcLast: 'آخر إضافة',
  adminAtcTime: 'الوقت',
  adminAtcSource: 'المصدر',
  adminAtcVisitor: 'الزائر',
  adminAtcRange1: 'اليوم',
  adminAtcRange7: '7 أيام',
  adminAtcRange14: '14 يوماً',
  adminAtcRange30: '30 يوماً',
  adminRevenue: 'الإيرادات',
  adminStories: 'القصص',
  adminAiCost: 'تكلفة الذكاء الاصطناعي',
  adminPreviewAttempts: 'محاولات المعاينة',
  adminPreviewsReady: 'معاينات جاهزة',
  adminRecentPreviewAttempts: 'أحدث محاولات المعاينة',
  adminSearchPlaceholder: 'بحث باسم الطفل، الاسم، البريد، الهاتف، أو رمز المشاركة…',
  adminColChild: 'الطفل',
  adminColRequester: 'صاحب الطلب',
  adminColContact: 'التواصل',
  adminColStory: 'القصة',
  adminColProduct: 'المنتج',
  adminColPrice: 'السعر',
  adminColPayment: 'الدفع',
  adminColStatus: 'الحالة',
  adminColCost: 'التكلفة',
  adminColTime: 'الوقت',
  adminColActions: 'إجراءات',
  adminPaid: 'مدفوع',
  adminUnpaid: 'غير مدفوع',
  adminEditScenes: 'تعديل المشاهد',
  adminView: 'عرض',
  adminDemo: 'نسخة تجريبية',
  adminCopyDemoLink: 'نسخ رابط النسخة التجريبية',
  adminDemoLinkCopied: 'تم نسخ الرابط ✓',
  adminDelete: 'حذف',
  adminNoAttemptsYet: 'لا توجد محاولات بعد',
  adminCostEstimateNote: 'التكلفة تقديرية بالدولار (أسعار المزوّدين).',
  adminPrevPage: 'السابق',
  adminNextPage: 'التالي',
  showcaseTitle: 'تصفّحوا قصصاً كاملة',
  showcaseSubtitle: 'هذه نماذج حقيقية من كتبنا — افتحوا أيّ كتاب واقرأوه صفحة صفحة قبل أن تطلبوا كتابكم.',
  showcaseOpen: 'افتح الكتاب',
  showcasePages: 'صفحة',
  showcasePrev: 'السابق',
  showcaseNext: 'التالي',
  adminDuplicate: 'نسخ',
  adminDuplicateStory: 'إنشاء نسخة من القصة',
  adminDuplicateTitle: 'إنشاء نسخة',
  adminDuplicateMessage: 'ستُنشأ قصة جديدة تحتوي على المشاهد والنصوص والصور والغلاف نفسها، ويمكن تعديلها بشكل مستقل. حدّد صفات النسخة:',
  adminDuplicateStatusLabel: 'حالة النسخة',
  adminDuplicateTestLabel: 'اعتبارها بيانات اختبار',
  adminDuplicatePaidLabel: 'اعتبارها مدفوعة (يُنشأ طلب مرتبط بها)',
  adminDuplicateSubmit: 'إنشاء النسخة',
  adminDuplicateFailed: 'فشل إنشاء النسخة',
  adminDuplicateRecastLabel: 'نسخة لطفل آخر (تغيير الاسم والجنس والصورة)',
  adminDuplicateChildName: 'اسم البطل الجديد',
  adminDuplicateChildGender: 'جنس البطل',
  adminDuplicateChildPhoto: 'صورة الطفل الجديد',
  adminDuplicateUploadPhoto: 'رفع صورة',
  adminDuplicateChangePhoto: 'تغيير الصورة',
  adminGenderBoy: 'ولد',
  adminGenderGirl: 'بنت',
  adminDuplicateRedrawLabel: 'إعادة رسم كل الصور بالطفل الجديد',
  adminDuplicateRedrawHint: 'الصور تبقى كما هي تمامًا — نفس التكوين والوضعية والخلفية والملابس — ويتغيّر الطفل فقط. تجري العملية في الخلفية صفحة بعد صفحة.',
  adminRecastRunning: 'يجري إعادة رسم الصور بالطفل الجديد',
  adminRecastDone: 'اكتملت إعادة رسم الصور',
  adminRecastPartial: 'صفحات لم تكتمل',
  adminDeletePreviewTitle: 'حذف المعاينة',
  adminDeletePreviewMessage: 'سيُحذف نهائياً سجل المعاينة ولا يمكن التراجع. هل تريد المتابعة؟',
  adminDeleteFailed: 'فشل الحذف',
  adminSaveFailed: 'فشل الحفظ',
  adminActionFailed: 'فشل الإجراء',
  adminStatusPreviewing: 'قيد الإنشاء',
  adminStatusPreviewReady: 'جاهزة',
  adminStatusFinalizing: 'قيد الإتمام',
  adminStatusFinalized: 'مكتملة',
  adminStatusIterating: 'قيد التعديل',
  adminStatusLockedForPrint: 'جاهزة للطباعة',
  adminStatusFailed: 'فشلت',
  adminStatusUnknown: 'غير معروف',
  adminVariantSoftcover: 'غلاف ورقي',
  adminVariantHardcover: 'غلاف مقوّى',
  adminStatusCancelled: 'ملغي',
  adminPaymentCard: '💳 بطاقة',
  adminPaymentCash: '💵 نقدي',
  adminPaymentBankTransfer: '🏦 تحويل بنكي',
  adminOrderSearchPlaceholder: 'بحث برقم الطلب، الاسم، البريد، الهاتف، أو رقم التتبّع…',
  adminFilterAll: 'الكل',
  adminManualBadge: 'يدوي',
  adminTestBadge: 'اختبار',
  adminViewPreview: 'عرض المعاينة',
  adminChangePaymentMethod: 'اضغط لتغيير طريقة الدفع',
  adminEditAmount: 'تعديل المبلغ',
  adminViewOnly: 'عرض فقط',
  adminColPaymentMethod: 'الدفع',
  adminColAction: 'إجراء',
  adminSettingsTitle: 'الإعدادات',
  adminStripeHelp: 'المفتاح الفعّال يتغيّر مباشرة عند تبديل الوضع — لا حاجة لإعادة تشغيل الخادم.',
  adminStripeMode: 'وضع Stripe',
  adminStripeKeysHint: 'يقرأ المفاتيح من ',
  adminSkipStripe: 'تخطي Stripe',
  adminSkipStripeHint: 'للتطوير فقط — الطلب يُعتبر مدفوعاً مباشرة',
  adminAiProviders: 'مزودو الذكاء الاصطناعي',
  adminAiProvidersHelp: 'التغييرات تسري على الطلبات الجديدة فور الحفظ. مفاتيح الـ API تبقى في ملف .env.',
  adminStoryGeneration: 'توليد القصة',
  adminIterationCap: 'سقف التكرار لكل مشهد',
  adminIterationCapHint: 'عدد المحاولات القصوى لإعادة توليد مشهد لم ينجح',
  adminStoryFont: 'خط نصّ القصة',
  adminStoryFontHelp: 'يُطبَّق هذا الخط على نصّ كل القصص — في الكتاب المطبوع (PDF) وفي العارض على الشاشة معاً. عناوين الأغلفة تحتفظ بخطّها الخاص لكل قصة.',
  adminStoryFontLabel: 'الخط',
  adminStoryFontHint: 'يسري على كل الملفات التي تُنتَج بعد الحفظ؛ الملفات المُنشأة سابقاً لا تتغيّر.',
  adminStoryFontSample: 'في المساء، جلس البطل قرب النافذة ونظر إلى النجوم، ثم ابتسم وقال: غداً يومٌ جديد.',
  adminMasterPrompt: 'برومبت رئيسي (Master Prompt)',
  adminMasterPromptEnabled: 'مُفعّل',
  adminMasterPromptDisabled: 'متوقّف',
  adminMasterPromptHelp: 'عند التفعيل، يحلّ هذا البرومبت محلّ كل مسارات القصص (الأبطال، الخيال، المخاوف، المحطات…) ويصبح هو البرومبت الوحيد لتوليد القصة. نُضيف حوله فقط متغيّرات الطفل (الاسم، العمر، الجنس، الموضوع…) قبله، وتعليمات البنية (عدد الصفحات، اللغة، شكل الـ JSON) بعده. عند إيقافه يعود النظام إلى المسارات الاعتيادية.',
  adminPromptText: 'نص البرومبت',
  adminPromptPlaceholder: 'اكتب هنا البرومبت الكامل لتوليد القصة…\nمتاح استخدام تفاصيل الطفل المُمرَّرة قبل هذا النص (الاسم، العمر، الجنس، الموضوع، النتيجة المرجوّة…).',
  adminPromptOutputHint: 'لا تكتب هنا شكل المخرجات (JSON) أو عدد الصفحات — تُضاف تلقائياً بعد البرومبت.',
  adminProductCatalog: 'كتالوج المنتجات والأسعار',
  adminAddProduct: '+ إضافة منتج',
  adminProductCatalogHelp: 'كل متغير في القوالب يربط بمنتج من هنا. السعر يُمرَّر إلى Stripe ك price_data لحظياً — لا حاجة لإنشاء Price IDs.',
  adminProductKey: 'المفتاح (key)',
  adminProductName: 'الاسم',
  adminProductPrice: 'السعر',
  adminProductCompareAt: 'قبل الخصم',
  adminProductCurrency: 'العملة',
  adminProductKeyRequired: 'كل منتج يحتاج مفتاح (key)',
  adminProductNameRequired: 'يحتاج اسماً',
  adminProductKeysDuplicate: 'مفاتيح المنتجات مكررة',
  adminNoProductsYet: 'لا توجد منتجات بعد — اضغط "إضافة منتج"',
  adminDeliveryFees: 'رسوم التوصيل',
  adminDeliveryFeesHelp: 'تُضاف هذه الرسوم تلقائياً إلى كل طلب مطبوع (غلاف ورقي أو مقوّى) عند الدفع، وتظهر للزبون كبند منفصل قبل Stripe وعلى صفحة الدفع.',
  adminDeliveryAmount: 'قيمة التوصيل',
  adminCurrencyField: 'العملة',
  adminGradBanner: 'بانر سلسلة التخرّج (الروضات)',
  adminGradBannerHelp: 'إظهار أو إخفاء بانر سلسلة تخرّج الروضة على الصفحة الرئيسية (الذي يفتح طلب واتساب خاص للصف).',
  adminPromoBanner: 'عرض ترويجي (بانر)',
  adminBannerImage: 'صورة البانر',
  adminBannerAlt: 'بانر',
  adminUploading: 'جارٍ الرفع…',
  adminPromoPrice: 'سعر العرض (للكتب)',
  adminBundleQty: 'عدد الكتب في المجموعة',
  adminProductTypeLabel: 'نوع المنتج',
  adminStartsAt: 'يبدأ في',
  adminEndsAt: 'ينتهي في',
  adminUnsavedChanges: 'التغييرات لا تُحفظ تلقائياً',
  adminSaving: 'جاري الحفظ…',
  adminSaveAllSettings: 'حفظ كل الإعدادات',
  adminSaved: 'تم الحفظ',
  adminImageUploadFailed: 'فشل رفع الصورة',
  adminBackToDashboard: '← لوحة التحكم',
  adminBannerGradSeries: 'بانر سلسلة تخرّج الروضة',
  adminBannerPromo: 'بانر العرض',
  adminRangeToday: 'اليوم',
  adminRange7Days: '٧ أيام',
  adminRange30Days: '٣٠ يوم',
  adminRange90Days: '٩٠ يوم',
  adminRangeAll: 'كل الوقت',
  adminRangeCustom: 'مخصص',
  adminExpenseAds: 'إعلانات',
  adminExpenseAi: 'ذكاء اصطناعي',
  adminExpensePrinting: 'طباعة',
  adminExpenseDelivery: 'توصيل',
  adminExpenseOther: 'أخرى',
  adminFrom: 'من',
  adminTo: 'إلى',
  adminSelectDateRange: 'اختر تاريخ البداية والنهاية',
  adminConversionFunnel: 'مسار التحويل',
  adminVisitors: 'زوّار',
  adminPreviews: 'معاينات',
  adminPurchases: 'مشتريات',
  adminFinancialPerformance: 'الأداء المالي',
  adminProductsCost: 'تكلفة المنتجات (طباعة+توصيل+ذكاء)',
  adminExpensesLabel: 'مصاريف (إعلانات…)',
  adminNetProfit: 'صافي الربح',
  adminProfitMargin: 'هامش الربح',
  adminActualAiSpend: 'إنفاق الذكاء الفعلي (مرجعي)',
  adminDailyIncomeSpend: 'الدخل والإنفاق اليومي',
  adminIncome: 'الدخل',
  adminSpend: 'الإنفاق',
  adminCostRates: 'معدلات التكلفة',
  adminBookPrinting: 'طباعة الكتاب (₪)',
  adminDeliveryCost: 'التوصيل (₪)',
  adminExchangeRate: 'سعر صرف الدولار',
  adminSaveRates: 'حفظ المعدلات',
  adminAiCostNote: 'تُحتسب تكلفة الذكاء الاصطناعي من الإنفاق الفعلي لكل قصة (بالدولار) مضروباً بسعر الصرف.',
  adminExpenses: 'المصاريف',
  adminExpenseDescription: 'الوصف',
  adminExpenseType: 'النوع',
  adminExpenseAmount: 'المبلغ (₪)',
  adminExpensePeriod: 'الفترة',
  adminExpensePeriodOption: 'فترة (يُوزّع يومياً)',
  adminExpenseOneTime: 'مرة واحدة',
  adminExpenseDate: 'التاريخ',
  adminExpenseAdd: 'إضافة',
  adminNoExpensesYet: 'لا توجد مصاريف بعد',
  adminExpenseDescPlaceholder: 'مثال: حملة فيسبوك أيلول',
  adminNoDataYet: 'لا توجد بيانات',
  adminEmailTracking: 'تتبع الإيميلات',
  adminEmailRecipient: 'المستلم',
  adminEmailType: 'النوع',
  adminEmailSubject: 'الموضوع',
  adminEmailSent: 'أُرسل',
  adminEmailOpened: 'فُتح؟',
  adminEmailOpenTime: 'وقت الفتح',
  adminEmailOpenCount: 'مرات',
  adminEmailYes: 'نعم',
  adminEmailNo: 'لا',
  adminEmailStatus: 'الحالة',
  adminEmailFilterOpened: 'مفتوحة',
  adminEmailFilterNotOpened: 'لم تُفتح',
  adminNoEmailsYet: 'لا توجد إيميلات مسجّلة بعد',
  adminEmailCount: 'إيميل',
  adminMostViewedStories: 'الأكثر مشاهدة (القصص)',
  adminMostPreviewed: 'الأكثر معاينة',
  adminMostViewedCategories: 'الأكثر مشاهدة (التصنيفات)',
  adminViewCountLabel: 'مشاهدة',
  adminPreviewCountLabel: 'معاينة',
  adminRankName: 'الاسم',
  adminEmailTypeOrderConfirmation: 'تأكيد طلب',
  adminEmailTypeStoryReady: 'القصة جاهزة',
  adminEmailTypeStoryPdf: 'تسليم PDF',
  adminEmailTypeBookReady: 'الكتاب جاهز',
  adminEmailTypeTeaser: 'تذكير معاينة',
  adminEmailTypeStoryFinalize: 'مراجعة واعتماد',
  adminEmailTypeAccountCreated: 'حساب جديد',
  adminEmailTypeMagicLogin: 'رابط دخول',
  adminEmailTypePasswordReset: 'استعادة كلمة مرور',
  adminEmailTypePaymentNotice: 'إشعار دفع (داخلي)',
  adminEmailTypeUnknown: 'أخرى',
  adminEmailFilterAll: 'الكل',
  adminEmailPaymentNoticeShort: 'إشعار دفع',
  adminNoImage: 'لا توجد صورة',
  adminRegeneratingImage: 'جارٍ التوليد…',
  adminRegenerateImage: 'إعادة توليد الصورة',
  adminUploadingImage: 'جارٍ الرفع…',
  adminUploadFromDevice: 'رفع صورة من جهازك',
  adminRegenCount: 'عدد مرات التوليد: ',
  adminTextPreviewLabel: 'معاينة النص كما سيظهر في الصفحة',
  adminSceneTextLabel: 'نص المشهد ',
  adminMoveUp: 'تحريك لأعلى',
  adminMoveDown: 'تحريك لأسفل',
  adminDeleteScene: 'حذف المشهد',
  adminFontSizeLabel: 'حجم الخط (نقطة pt — اتركه فارغًا للحجم التلقائي)',
  adminAutomatic: 'تلقائي',
  adminImagePromptLabel: 'وصف الصورة (image prompt)',
  adminGeneratePromptFromText: '✨ توليد الوصف من نص المشهد',
  adminGeneratePromptHint: 'يولّد وصف الصورة بالإنجليزية من نص المشهد أعلاه. عدّله ثم اضغط «إعادة توليد الصورة».',
  adminRefImagesLabel: 'صور مرجعية لهذا المشهد',
  adminRefImagesHelp: 'تُرسَل هذه الصور مع توليد هذا المشهد فقط (إضافةً إلى مرجع الشخصية) — مثلاً غرض أو خلفية يجب أن تظهر.',
  adminRefSubjectPlaceholder: 'ماذا تمثل الصورة؟ (اختياري) مثال: دراجة حمراء',
  adminDeleteRefImage: 'حذف الصورة المرجعية',
  adminAddingRef: 'جارٍ الإضافة…',
  adminAddRefImage: '+ إضافة صورة مرجعية',
  adminSavingText: 'جارٍ الحفظ…',
  adminSaveText: 'حفظ النص',
  adminSavedCheckmark: 'تم الحفظ ✓',
  adminNoCover: 'لا يوجد غلاف',
  adminFrontCoverHint: 'الغلاف الأمامي — اسحب العنوان لتحريكه، وانقر سطراً لتنسيقه',
  adminTrimLine: 'خط القص — 2 سم',
  adminShowTrimGuide: 'إظهار خط القص (2 سم) — للمعاينة فقط، لا يظهر في الكتاب',
  adminSaveTitlePos: 'حفظ موقع العنوان',
  adminResetTitlePos: 'إعادة الموقع الافتراضي',
  adminFullCoverPrint: 'الغلاف الكامل للطباعة (أمامي يسار + خلفي يمين)',
  adminRegenerateCover: 'إعادة توليد الغلاف',
  adminUploadCover: 'رفع غلاف من جهازك',
  adminStoryTitleLabel: 'عنوان القصة',
  adminStoryTitlePlaceholder: 'عنوان القصة كما يظهر على الغلاف والكتاب',
  adminSaveTitle: 'حفظ العنوان',
  adminCoverConcept: 'فكرة الغلاف (cover concept)',
  adminCoverConceptPlaceholder: 'صِف مشهد/فكرة الغلاف بالإنجليزية (المكان، العنصر البصري الأساسي، الجو). يُطبَّق نمط الرسم التلقائي (شبه واقعي مرسوم) دائماً — لا تكتب نوع الرسم. اتركه فارغاً للغلاف الافتراضي.',
  adminCoverRefImages: 'صور مرجعية للغلاف',
  adminCoverRefHelp: 'تُرسَل هذه الصور مع توليد الغلاف (إضافةً إلى مرجع الشخصية) — مثلاً غرض أو خلفية يجب أن تظهر على الغلاف. تظهر بجانب البطل في الجهة اليسرى.',
  adminCoverTitleColor: 'لون عنوان الغلاف',
  adminDarkText: 'نص داكن',
  adminLightText: 'نص فاتح',
  adminTitleDesign: 'تصميم العنوان',
  adminTitleDesignHelp: 'انقر أي سطر من العنوان في المعاينة بالأعلى لتنسيقه (الخط، الألوان، الحدود، الحجم، التباعد).',
  adminOpenTitleEditor: '✎ فتح محرّر العنوان',
  adminTextBubble: 'فقاعة مرسومة يدوياً خلف النص',
  adminTextBubbleSaving: ' — جارٍ الحفظ…',
  adminDragTitleHint: 'اسحب لتحريك العنوان — انقر سطراً لتنسيقه',
  adminTitleDesigner: '⠿ تصميم العنوان',
  adminCloseTitleEditor: 'إغلاق',
  adminTitleLine: 'سطر ',
  adminFont: 'الخط',
  adminDefault: 'افتراضي',
  adminSizePt: 'الحجم (pt)',
  adminWeight: 'السماكة',
  adminColor: 'اللون',
  adminBorder: 'الحدود',
  adminBorderWidth: 'سماكة الحدود',
  adminLetterSpacing: 'تباعد الأحرف (em)',
  adminBoxWidth: 'عرض الصندوق: ',
  adminLineSpacing: 'تباعد الأسطر: ',
  adminSaveBtn: 'حفظ',
  adminResetBtn: 'إعادة ضبط',
  adminNoPortrait: 'لا توجد صورة شخصية لهذه القصة بعد.',
  adminDedicationImage: 'صورة صفحة الإهداء',
  adminDedicationHeroImage: 'صفحة الإهداء — صورة البطل',
  adminDedicationUploadHelp: 'ارفع صورة الطفل التي تظهر في دائرة صفحة الإهداء.',
  adminReplaceImage: 'استبدال الصورة',
  adminImageFraming: 'تأطير الصورة',
  adminFramingHelp: 'اسحب الصورة داخل الدائرة لتحريكها، واستخدم الشريط للتكبير — لتظهر بالشكل الصحيح في الكتاب وملف الـ PDF.',
  adminZoom: 'تكبير',
  adminSaveFraming: 'حفظ التأطير',
  adminBackCover: 'الغلاف الخلفي',
  adminBackCoverSummaryLabel: 'النص التعريفي (أعلى الغلاف الخلفي)',
  adminBackCoverAutoPrefix: 'اتركه فارغاً لاستخدام النص التلقائي: ',
  adminBackCoverDedicationLabel: 'الإهداء (أسفل الغلاف الخلفي)',
  adminBackCoverDedicationAutoPrefix: 'اتركه فارغاً لاستخدام الإهداء التلقائي: ',
  adminSaveBackCover: 'حفظ الغلاف الخلفي',
  adminHeroDetails: 'تفاصيل البطل',
  adminHeroDetailsHelp: 'اسم البطل وجنسه يظهران في الإهداء والنص التعريفي على الغلاف الخلفي.',
  adminHeroName: 'اسم البطل',
  adminHeroNamePlaceholder: 'اسم الطفل في القصة',
  adminGender: 'الجنس',
  adminGenderUnspecified: '— غير محدّد —',
  adminGenderBoy: 'ولد',
  adminGenderGirl: 'بنت',
  adminAgeLabel: 'العمر',
  adminAgePlaceholder: 'مثال: 4',
  adminSaveHeroDetails: 'حفظ تفاصيل البطل',
  adminOrderDetailsHeading: 'تفاصيل الطلب',
  adminAllOrders: 'كل الطلبات',
  adminCustomerName: 'اسم العميل',
  adminEmailLabel: 'البريد الإلكتروني',
  adminPhoneLabel: 'الهاتف',
  adminProductTypeField: 'نوع المنتج',
  adminPriceField: 'السعر (₪)',
  adminQuantity: 'الكمية',
  adminOrderStatusField: 'حالة الطلب',
  adminStatusNotPaid: 'غير مدفوع',
  adminStatusPaid: 'مدفوع',
  adminStatusInProduction: 'قيد الإنتاج',
  adminStatusShipped: 'تم الشحن',
  adminStatusDelivered: 'تم التسليم',
  adminStatusCancelledLabel: 'ملغى',
  adminSaveOrderDetails: 'حفظ تفاصيل الطلب',
  adminPreparingPdf: 'جارٍ تجهيز PDF…',
  adminDownloadBookPdf: 'تنزيل الكتاب PDF',
  adminPdfCover: 'PDF الغلاف',
  adminPdfContent: 'PDF المحتوى (صفحة صفحة)',
  adminProductSoftcover: 'غلاف ورقي',
  adminProductHardcover: 'غلاف مقوّى',
  adminProductDigital: 'نسخة رقمية (PDF)',
  adminImageStyle: 'نمط الرسومات',
  adminImageStyleHelpText: 'طريقة رسم كل صور القصة. عند تغييره وحفظه يمكنك إعادة توليد كل الصور الموجودة بالنمط الجديد بضغطة واحدة.',
  adminStyleCartoon: 'كرتون',
  adminStyle3d: 'ثلاثي الأبعاد',
  adminStyleRealistic: 'واقعي',
  adminSaveStyle: 'حفظ النمط',
  adminRegenImagesProgress: 'جارٍ إعادة توليد الصور… ',
  adminCurrentStyle: 'النمط الحالي: ',
  adminEditScenesTitle: 'تعديل المشاهد',
  adminStoryDefault: 'قصة',
  adminHeroLabel: 'البطل: ',
  adminStatusPrefix: 'الحالة: ',
  adminViewSeries: '📚 عرض السلسلة',
  adminCreateSeriesFromStory: '📚 إنشاء سلسلة من هذه القصة',
  adminPreviewLinkLabel: 'رابط المعاينة للعميل (عرض + دفع):',
  adminCopied: 'تم النسخ ✓',
  adminCopyLink: '📋 نسخ الرابط',
  adminOpenPreview: 'فتح المعاينة ↗',
  adminCopyFullScript: '📋 نسخ نص القصة كاملاً',
  adminCreatingCopy: 'جارٍ إنشاء النسخة…',
  adminNewPreviewOpened: 'فُتحت المعاينة الجديدة في تبويب آخر — اضغط هنا إن لم تُفتح',
  adminAddSceneEnd: '+ إضافة مشهد جديد في النهاية',
  adminBusy: 'جارٍ…',
  adminGoBack: 'رجوع',
  adminDedicationPortraitOptional: 'صورة صفحة الإهداء (اختياري)',
  adminChangeImage: 'تغيير الصورة',
  adminRemove: 'إزالة',
  adminBuildStoryTitle: 'بناء قصة يدويًا',
  adminBackToOrders: 'رجوع للطلبات',
  adminBuildStoryDesc: 'أنشئ كتابًا خارجيًا يدويًا: العنوان والمشاهد وتفاصيل الطلب. بعد الإنشاء يمكنك إضافة صور الغلاف والمشاهد (رفع صورة أو توليد من صورة مرجعية + وصف) في محرّر القصة.',
  adminVersionType: 'نوع النسخة',
  adminFullVersion: 'نسخة كاملة (جاهزة للإنتاج)',
  adminFullVersionDesc: 'كتاب نهائي بكل المشاهد والصور — يُعامَل كقصة منتهية.',
  adminPreviewVersion: 'معاينة (Preview)',
  adminPreviewVersionDesc: 'مثل معاينة العميل: أضِف صورة الغلاف والمشهد الأول فقط، وتبقى باقي المشاهد مقفلة. أرسل رابط المعاينة للعميل ليطّلع ويدفع.',
  adminPaymentStatus: 'حالة الدفع',
  adminScenes: 'المشاهد',
  adminAllScenesFontSize: 'حجم الخط لكل المشاهد (نقطة pt — يُطبَّق على جميع المشاهد)',
  adminPerSceneFontOverride: 'يمكنك تغيير حجم الخط لمشهد معيّن أدناه، وسيتجاوز القيمة العامة.',
  adminSceneFontSizeHint: 'حجم الخط (نقطة pt — اتركه فارغًا لاستخدام القيمة العامة)',
  adminAddScene: '+ إضافة مشهد',
  adminEnterStoryTitle: 'أدخل عنوان القصة',
  adminCreating: 'جارٍ الإنشاء…',
  adminCreateAndContinue: 'إنشاء القصة ومتابعة التحرير',
  adminCreateStoryFailed: 'فشل إنشاء القصة',
  adminGlobalSuffix: '(عام)',
  adminTemplateName: 'الاسم',
  adminTemplateVariants: 'المتغيرات',
  adminTemplateFrom: 'من',
  adminTemplateActive: 'مفعّل',
  adminTemplateInactive: 'معطّل',
  adminTemplateAction: 'إجراء',
  adminTemplateClose: 'إغلاق',
  adminTemplateEdit: 'تعديل',
  adminTemplateTagline: 'الوصف القصير',
  adminTemplateDescription: 'الوصف',
  adminTemplateCoverUrl: 'رابط صورة الغلاف',
  adminTemplateSortOrder: 'ترتيب العرض',
  adminTemplateFeatured: 'الأكثر طلباً',
  adminTemplateVariantsTitle: 'المتغيرات والمنتجات',
  adminTemplateAddVariant: '+ إضافة متغير',
  adminTemplateVariantType: 'النوع',
  adminTemplateVariantProduct: 'المنتج (السعر)',
  adminTemplateVariantEnabled: 'مفعّل',
  adminTemplateSelectProduct: '— اختر منتج —',
  adminTemplateNoVariants: 'لا توجد متغيرات بعد',
  adminTemplateNoProducts: 'لا توجد منتجات في الكتالوج بعد. أضفها من ',
  adminTemplateSettingsLink: 'الإعدادات',
  adminTemplateNeedProducts: 'أضف منتجات أولاً في الإعدادات قبل ربط المتغيرات',
  adminTemplateSkuRequired: 'كل متغير يحتاج SKU',
  adminTemplateProductRequired: 'كل متغير يحتاج اختيار منتج',
  adminTemplateSaving: 'جاري الحفظ…',
  adminTemplateSave: 'حفظ',
  adminTemplateCancelEdit: 'إلغاء',
  adminUserName: 'الاسم',
  adminUserRole: 'الدور',
  adminUserDate: 'تاريخ التسجيل',
  adminSeriesStatusDraft: 'مسودة',
  adminSeriesStatusGenerating: 'جارِ التوليد…',
  adminSeriesStatusReady: 'جاهز',
  adminSeriesStatusFailed: 'فشل',
  adminSeriesSameStory: 'نفس القصة',
  adminSeriesNewStory: 'قصة جديدة',
  adminSeriesSameGraphics: 'نفس الرسومات',
  adminSeriesNewGraphics: 'رسومات جديدة',
  adminSeriesChildren: ' أطفال',
  adminSeriesApprovedCount: ' معتمد',
  adminSeriesDefaultPrice: 'السعر الافتراضي (₪): ',
  adminSeriesTest: 'سلسلة تجريبية',
  adminSeriesAddChild: '+ إضافة طفل',
  adminSeriesAdd5: '+ إضافة 5',
  adminSeriesChildName: 'اسم الطفل',
  adminSeriesChildAge: 'العمر',
  adminSeriesChildPhoto: 'صورة الطفل:',
  adminSeriesRefPhoto: 'صورة مرجعية:',
  adminSeriesUploading: '…رفع',
  adminSeriesChange: 'تغيير',
  adminSeriesUpload: 'رفع',
  adminSeriesUploadPhotoFirst: 'ارفع صورة الطفل قبل إنشاء الكتاب.',
  adminSeriesCreateBook: 'إنشاء الكتاب',
  adminSeriesRegenerate: 'إعادة توليد',
  adminSeriesRetry: 'إعادة المحاولة',
  adminSeriesGenerating: '…جارِ التوليد',
  adminSeriesEditScenes: 'تعديل المشاهد',
  adminSeriesViewPdf: 'عرض PDF',
  adminSeriesApprove: 'اعتماد',
  adminSeriesApprovedBadge: '✓ معتمد',
  adminSeriesDeleteChild: '🗑 حذف',
  adminSeriesDeleteConfirm: 'حذف هذا الطفل من السلسلة؟',
  adminSeriesTitle: 'عنوان السلسلة',
  adminSeriesPdfFailed: 'تعذّر فتح ملف الـ PDF',
  adminSeriesLoadFailed: 'تعذّر التحميل',
  adminSeriesLoading: 'جارِ التحميل…',
  adminSeriesListTitle: 'السلاسل',
  adminSeriesEmptyHelp: 'لا توجد سلاسل بعد. افتح قصة جاهزة واضغط «إنشاء سلسلة من هذه القصة».',
  adminSeriesColTitle: 'العنوان',
  adminSeriesColChildren: 'الأطفال',
  adminSeriesColApproved: 'المعتمد',
  adminSeriesColType: 'النوع',
  adminSeriesColDate: 'التاريخ',
  adminCreateSeries: 'إنشاء سلسلة',
  adminFromStory: 'من القصة: ',
  adminStepStory: 'القصة',
  adminStepGraphics: 'الرسومات',
  adminStepCount: 'العدد',
  adminStepChildren: 'الأطفال (اختياري)',
  adminStoryText: 'القصة (النص)',
  adminSameStory: 'نفس القصة',
  adminSameStoryDesc: 'نفس النص تمامًا، مع تبديل الاسم وملاءمة صيغة المذكّر/المؤنّث لكل طفل.',
  adminNewStoryPerChild: 'قصة جديدة لكل طفل',
  adminNewStoryPerChildDesc: 'نفس القالب والفكرة، لكن يكتب الذكاء الاصطناعي نصًّا جديدًا لكل طفل.',
  adminGraphicsLabel: 'الرسومات',
  adminSameGraphicsLabel: 'نفس الرسومات',
  adminSameGraphicsDesc: 'نفس الصور تمامًا مع تبديل وجه الطفل — نثبّت صورة القصة الأصلية كمرجع ونطلب من النموذج إعادة إنتاجها بنفس التكوين.',
  adminNewGraphics: 'رسومات جديدة',
  adminNewGraphicsDesc: 'نولّد صورًا جديدة لكل طفل اعتمادًا على النص، مع الحفاظ على النمط.',
  adminWizardSettings: 'الإعدادات',
  adminChildrenCount: 'عدد الأطفال',
  adminSeriesTitleField: 'عنوان السلسلة',
  adminSeriesTitlePlaceholder: 'مثلاً: روضة الأمل - الفوج أ',
  adminDefaultPricePerBook: 'السعر الافتراضي لكل كتاب (₪)',
  adminDefaultPricePlaceholder: 'مثلاً 200',
  adminTestSeries: 'سلسلة تجريبية (لا تُحتسب في الإحصائيات)',
  adminNext: 'التالي',
  adminChildrenOptionalTitle: 'الأطفال (اختياري)',
  adminChildrenPrefillHelp: 'يمكنك تعبئة الأسماء الآن أو لاحقًا. الصور والأسعار والتوليد تتم في صفحة إدارة السلسلة بعد الإنشاء.',
  adminChildNameOptional: 'اسم الطفل (اختياري)',
  adminBack: 'رجوع',
  adminCreateSeriesAndManage: 'إنشاء السلسلة وإدارتها',
  adminCreatingSeries: 'جارِ الإنشاء…',
  adminBaseStoryNotSet: 'لم يتم تحديد القصة الأساسية',

  // Footer
  footerText: 'أنا البطل — قصص شخصية لأطفالك',
  footerTagline: 'نكتب ونرسم لطفلك قصةً يكون فيها هو البطل.',
  footerExploreTitle: 'استكشف',
  footerHowItWorks: 'كيف نعمل؟',
  footerTherapeutic: 'المحتوى العلاجي',
  footerBlog: 'المدوّنة',
  footerTerms: 'الشروط والأحكام',
  footerContactTitle: 'تواصل معنا',
  footerWhatsApp: 'واتساب',
  footerRights: 'جميع الحقوق محفوظة',

  // How it works page
  howItWorksTitle: 'ماذا يحدث بعد أن تطلب؟',
  howItWorksLede: 'لحظة إتمام طلبك، تبدأ رحلةٌ قصيرة نتكفّل فيها بكل التفاصيل — من إكمال الرسوم، إلى مراجعتها معك، إلى إتقانها، ثم تسليمها. إليك كل خطوة بوضوح.',
  howItWorksStep1Title: 'الطلب والدفع',
  howItWorksStep1Text: 'تختار قصتك وتُكمل الدفع الآمن عبر Stripe. تصلك رسالة تأكيد فوراً، ويظهر الطلب في حسابك على الفور.',
  howItWorksStep2Title: 'نُكمل رسم قصتك',
  howItWorksStep2Text: 'بعد الدفع نرسم باقي مشاهد القصة بالأسلوب نفسه. تستغرق هذه الخطوة دقائق قليلة عادةً.',
  howItWorksStep3Title: 'المراجعة والتعديل',
  howItWorksStep3Text: 'تتصفّح قصتك كاملةً، ويمكنك طلب أي تعديل على النص أو الرسوم. كما يمرّ كل كتاب على فريقنا الذي يدقّق اللغة ويُحسّن الرسومات قبل أن تُعتمد.',
  howItWorksStep4Title: 'اطمئن، والباقي علينا',
  howItWorksStep4Text: 'دفعت ومنحتنا ثقتك، وهذا يكفي. نتكفّل بإتقان قصتك حتى آخر تفصيل ونُجهّزها للطباعة والتسليم، دون أن نُثقل عليك بأيّ خطوة.',
  howItWorksStep5Title: 'التجهيز والتسليم',
  howItWorksStep5Text: 'بعد المراجعة، نُجهّز نسختك ونوصّلها إليك:',
  howItWorksDeliveryDigital: 'النسخة الرقمية (PDF)',
  howItWorksDeliveryDigitalTime: 'فوراً بعد المراجعة',
  howItWorksDeliveryPrint: 'النسخة المطبوعة',
  howItWorksDeliveryPrintTime: 'من ١٠ إلى ١٤ يوم عمل (داخل البلاد)',
  howItWorksStep6Title: 'تتبّع حالة طلبك',
  howItWorksStep6Text: 'يمكنك متابعة حالة طلبك في أي وقت من صفحة «قصصي» في حسابك. تنتقل حالة الطلب عبر هذه المراحل:',
  howItWorksStatusCta: 'اذهب إلى قصصي',
  howItWorksHelpTitle: 'هل لديك سؤال؟',
  howItWorksHelpText: 'نحن هنا في كل خطوة. تواصل معنا عبر واتساب أو البريد الإلكتروني وسنردّ عليك بسرعة.',

  // StoryLoader
  storyLoaderTitle: 'نُنشئ قصة طفلك ✨',
  storyLoaderSubtitle: 'دقائق قليلة وتصبح القصة جاهزة — لا تغلق هذه الصفحة',

  // Header
  menuToggle: 'القائمة',

  // PromoBanner
  promoAriaLabel: 'عرض ترويجي',
  promoEyebrow: 'عرض خاص لفترة محدودة',
  promoHeadline: '{books} قصص مخصّصة بسعر مميّز',
  promoBundleDual: 'كتابين',
  promoBundlePlural: '{n} كتب',
  promoCta: 'ابدأ قصتك ←',

  // Book dedication / back-cover
  dedicationTitleGirl: 'إلى بطلتنا الصغيرة',
  dedicationTitleBoy: 'إلى بطلنا الصغير',
  dedicationTitleNameGirl: 'إلى {name} البطلة',
  dedicationTitleNameBoy: 'إلى {name} البطل',
  summaryNameGirl: 'في هذه الحكاية، تنطلق {name} في مغامرة صغيرة مليئة بالدفء والخيال، تكتشف فيها قوّتها الخاصة، وتتعلّم أن الشجاعة تكبر معها خطوة بعد خطوة.\nقصة كُتبت ورُسمت خصيصاً لها — لتكون هي البطلة.',
  summaryNameBoy: 'في هذه الحكاية، ينطلق {name} في مغامرة صغيرة مليئة بالدفء والخيال، يكتشف فيها قوّته الخاصة، ويتعلّم أن الشجاعة تكبر معه خطوة بعد خطوة.\nقصة كُتبت ورُسمت خصيصاً له — ليكون هو البطل.',
  summaryNoNameGirl: 'في هذه الحكاية، تنطلق بطلتنا الصغيرة في مغامرة مليئة بالدفء والخيال، تكتشف فيها قوّتها الخاصة، وتتعلّم أن الشجاعة تكبر معها خطوة بعد خطوة.\nقصة كُتبت ورُسمت خصيصاً لها.',
  summaryNoNameBoy: 'في هذه الحكاية، ينطلق بطلنا الصغير في مغامرة مليئة بالدفء والخيال، يكتشف فيها قوّته الخاصة، ويتعلّم أن الشجاعة تكبر معه خطوة بعد خطوة.\nقصة كُتبت ورُسمت خصيصاً له.',
  dedicationTextGirl: 'هذه القصة كُتبت ورُسمت خصيصاً لكِ، ولا توجد نسخة أخرى منها في العالم كلّه.\nاحتفظي بها جيداً، وكلما كبرتِ وعدتِ إلى صفحاتها، تذكّري أن الشجاعة لم تأتِ من الحكاية — بل كانت فيكِ منذ البداية.\nكوني دائماً بطلة حكايتكِ.',
  dedicationTextBoy: 'هذه القصة كُتبت ورُسمت خصيصاً لك، ولا توجد نسخة أخرى منها في العالم كلّه.\nاحتفظ بها جيداً، وكلما كبرت وعدت إلى صفحاتها، تذكّر أن الشجاعة لم تأتِ من الحكاية — بل كانت فيك منذ البداية.\nكن دائماً بطل حكايتك.',
  madeWithLoveIn: 'صُنعت بحبّ في {year}',

  // Top promo bar (site-wide announcement strip)
  topBarAria: 'كوبون الخصم مُفعّل',
  topBarReason: 'تم تفعيل كوبون الخصم',
  topBarSave: 'وفّروا {amount}₪',
  topBarCta: 'ابدأوا قصتكم',

  // Graduation series banner
  gradBannerBadge: 'جديد — طلب خاص للروضات',
  gradBannerTitle: '🎓 سلسلة تخرّج الروضة',
  gradBannerText: 'قصة واحدة لكل الصف — كل طفل بطل نسخته الخاصة باسمه وصورته، وكل رفاقه جزء من الحكاية.',
  gradBannerPriceUnit: 'للكتاب بغلاف مقوّى',
  gradBannerSave: 'وفّروا {amount}₪ لكل كتاب',
  gradBannerCta: 'اطلبوا الآن ←',
  gradModalClose: 'إغلاق',
  gradModalTitle: 'طلب سلسلة تخرّج الروضة 🎓',
  gradModalText: 'قصة واحدة لكل الصف، يكون فيها كل طفل بطل نسخته الخاصة. أكملوا التفاصيل وسنكمل الطلب معكم عبر واتساب.',
  gradModalCountLabel: 'كم عدد الكتب المطلوبة؟',
  gradModalCountPlaceholder: 'الحد الأدنى 10 كتب — مثال: 25',
  gradModalCountHelper: 'الحد الأدنى 10 كتب للحصول على سعر السلسلة (200₪ للكتاب).',
  gradModalDeadlineLabel: 'ما هو الموعد النهائي للتسليم؟',
  gradModalPriceRow: 'سعر السلسلة',
  gradModalPricePerBook: 'لكل كتاب بغلاف مقوّى — لطلبات',
  gradModalPriceMinBooks: '10 كتب',
  gradModalPriceOrMore: 'فأكثر',
  gradModalTotal: 'الإجمالي ({n} كتاب):',
  gradModalSavings: 'توفير {amount}₪',
  gradModalBelowMin: 'العدد أقل من الحد الأدنى (10 كتب). سعر 200₪ لا ينطبق على طلبات أصغر — أكملوا الطلب وسنتواصل معكم لترتيب التفاصيل والسعر المناسب.',
  gradModalHint: 'كل ما زاد عدد الكتب، زاد التوفير — صف من {count} كتاب يوفّر {amount}₪.',
  gradModalSubmit: 'متابعة عبر واتساب',
  gradWhatsAppLine1: 'مرحباً، أرغب بطلب سلسلة تخرّج الروضة',
  gradWhatsAppLine2: 'قصة واحدة لكل الصف، يكون فيها كل طفل بطل نسخته الخاصة باسمه وصورته.',
  gradWhatsAppCount: 'عدد الكتب المطلوبة: {n}',
  gradWhatsAppDeadline: 'الموعد النهائي للتسليم: {deadline}',
  gradWhatsAppBelowMin: 'ملاحظة: العدد أقل من 10 كتب — يرجى تزويدي بالتفاصيل والسعر المناسب.',
  gradTrackName: 'سلسلة تخرّج الروضة',

  // Home page
  heroSocialReview: 'مراجعة لكل قصة',
  heroSocialFormats: 'نسخة رقمية أو مطبوعة',
  heroFeatureMore: 'اعرف أكثر ←',
  categoryBadgeTherapy: 'نهج علاجي',
  promoBadgeNew: 'جديد — قصة الموسم',
  promoStartCta: 'ابدأ قصة طفلك ←',
  reviewsSectionTitle: 'ماذا قال الأهالي',
  waProofTitle: 'رسائل حقيقية من أهالي',
  waProofSubtitle: 'لقطات شاشة فعلية من محادثاتنا على واتساب (أخفينا الأرقام للخصوصية)',
  waProofView: 'اضغط للتكبير',
  waProofAlt: 'رسالة واتساب من أحد الأهالي',
  seTitle: 'أهالٍ جرّبوا قبلكم',
  seLede: 'فيديوهات ورسائل حقيقية من أهالٍ طلبوا قصصًا لأطفالهم — دون أي تعديل.',
  seVideosTitle: 'فيديوهات من الأهالي',
  seCta: 'ابدأ قصة طفلك ←',
  categoryCoverTherapy: 'نيل والبالونات',
  categoryCoverHeroes: 'سما البطلة الخارقة',
  categoryCoverBirthday: 'مجد في الفضاء',
  categoryCoverMilestones: 'آدم في الروضة',

  // Preview page
  previewGoToOrder: 'الذهاب إلى الطلب',
  trustPaymentSecure: 'دفع آمن عبر Stripe',
  trustRatingOf: 'من',
  trustRatingReview: 'تقييم',

  // Checkout page
  adminFreeNotice: 'إنشاء مجاني للفريق — لن يتم تحصيل أي مبلغ.',
  adminFreeBtn: 'إنشاء مجاني',
  checkoutTrustSsl: 'اتصال مشفّر SSL',
  checkoutTrustStripe: 'دفع آمن عبر Stripe',
  checkoutDeliveryEstimate: 'الطباعة والتوصيل تستغرق من ١٠ إلى ١٤ يوم عمل داخل البلاد.',

  // Cart page
  cartChildPrefix: 'لـ ',
  cartStoryFallback: 'قصة',

  // Account page
  statusCancelled: 'ملغي',
  accountNameLabel: 'الاسم',
  accountNoOrders: 'لا توجد طلبات بعد',

  // Register page
  registerNameLabel: 'الاسم',

  // Order detail page
  orderRequestNoDetails: 'لا توجد تفاصيل.',
  orderRequestFieldName: 'اسم الطفل',
  orderRequestFieldAge: 'العمر',
  orderRequestFieldGender: 'الجنس',
  orderRequestFieldIssue: 'التحدّي / المشكلة',
  orderRequestFieldCustomFear: 'الخوف المحدّد',
  orderRequestFieldWhenHappens: 'متى يحدث',
  orderRequestFieldHowBehaves: 'كيف يتصرّف',
  orderRequestFieldSmallGoal: 'الهدف الصغير',
  orderRequestFieldFamilyStructure: 'تركيبة العائلة',
  orderRequestFieldPersonalityTraits: 'صفات الشخصية',
  orderRequestFieldInterests: 'الاهتمامات',
  orderRequestFieldEnvironment: 'البيئة / المكان',
  orderRequestFieldStoryLanguage: 'لغة القصة',
  orderRequestFieldImageStyle: 'نمط الرسومات',
  orderRequestFieldDialect: 'اللهجة',
  orderRequestFieldVariantSku: 'المنتج',
  orderUploadedImages: 'الصور المرفوعة',
  orderChildPhoto: 'صورة الطفل',
  orderReferenceImage: 'مرجع',
  orderAdminToolsTag: 'أدوات المشرف',
  orderAdminEditScenes: 'تعديل المشاهد',
  orderAdminPdfBusy: 'جارٍ تجهيز PDF…',
  orderAdminPdfCover: 'PDF الغلاف',
  orderAdminPdfPages: 'PDF المحتوى (صفحة صفحة)',
  orderAdminBarcodeLabel: 'باركود',
  orderAdminAssigningBarcode: 'جارٍ التعيين…',
  orderAdminAssignBarcode: 'تعيين باركود',
  orderAdminRequestTitle: 'تفاصيل الطلب المُدخلة',
  orderAdminRequestHint: 'عرض كل ما أدخله العميل في النموذج، بما في ذلك الصور المرفوعة.',
  orderAdminRequestLoading: 'جاري التحميل…',
  orderAdminRequestBtn: 'عرض تفاصيل الطلب',
  orderPrintPdfError: 'فشل إنشاء PDF للطباعة: ',
  orderPrintPdfErrorUnknown: 'خطأ غير معروف',
  orderBarcodeError: 'فشل إنشاء الباركود: ',

  // TemplateDetail page
  templateReviewCount: 'تقييم',

  // Terms page
  termsPageTitle: 'الشروط والأحكام وسياسة الخصوصية',
  termsLastUpdated: 'آخر تحديث',
  termsSection1Title: '١. مقدمة وقبول الشروط',
  termsSection1P1: 'مرحباً بك في «{tradeName}» (ويُشار إليه في هذه الوثيقة بـ«المنصّة» أو «الخدمة»)، وهو اسم تجاري تُشغّله {legalName} ومقرّها في دولة إسرائيل. تتيح المنصّة إنشاء قصص أطفال مخصّصة ومصوّرة باستخدام تقنيات الذكاء الاصطناعي، بصيغة رقمية و/أو مطبوعة.',
  termsSection1P2: 'باستخدامك للمنصّة، أو بإنشائك حساباً، أو بإتمامك أي طلب، فإنك تُقرّ بأنك قرأت هذه الشروط والأحكام وسياسة الخصوصية، ووافقت عليها وعلى الالتزام بها. إذا كنت لا توافق على أيٍّ من هذه الشروط، فيُرجى عدم استخدام المنصّة.',
  termsSection2Title: '٢. تعريفات',
  termsSection2Items: [
    '«المنصّة» / «الخدمة»: موقع «{tradeName}» وما يتّصل به من خدمات وتطبيقات.',
    '«المستخدم» / «أنت»: كل شخص يستخدم المنصّة أو ينشئ حساباً أو يُتمّ طلباً.',
    '«الوصيّ»: الوالد أو الوصيّ القانوني للطفل صاحب القصة.',
    '«المحتوى المُرفوع»: الصور والأسماء والمعلومات والتفاصيل التي يُدخلها المستخدم لإنشاء القصة.',
    '«القصة»: العمل النصّي والمصوَّر الذي تُنشئه المنصّة استناداً إلى المحتوى المُرفوع.',
  ],
  termsSection3Title: '٣. وصف الخدمة',
  termsSection3P1: 'تُنشئ المنصّة قصصاً مخصّصة (علاجية داعمة، أو خيالية، أو بطولية) يكون فيها الطفل هو الشخصية الرئيسية، مع رسومات يولّدها الذكاء الاصطناعي بالاستناد إلى المعلومات والصور التي يقدّمها المستخدم. تُتاح القصة بصيغة رقمية (PDF) و/أو ككتاب مطبوع يُشحَن إلى العنوان الذي يحدّده المستخدم.',
  termsSection3P2: 'نسعى لتقديم نتائج عالية الجودة، غير أن المحتوى المُولَّد بالذكاء الاصطناعي قد يتضمّن اختلافات أو أخطاء؛ ولذلك تُتاح للمستخدم مرحلة مراجعة واعتماد للقصة قبل إرسالها للطباعة.',
  termsSection4Title: '٤. الأهلية واستخدام البالغين نيابةً عن الأطفال',
  termsSection4Items: [
    'يجب أن يكون مُنشئ الحساب ومُتمّ الطلب بالغاً (١٨ عاماً فأكثر) ويتمتّع بالأهلية القانونية الكاملة للتعاقد.',
    'المنصّة غير موجَّهة للأطفال، ولا يجوز للأطفال إنشاء حسابات أو إتمام طلبات أو رفع محتوى بأنفسهم.',
    'تُنشأ القصص المتعلّقة بالأطفال حصراً من قِبَل الوالد أو الوصيّ القانوني، أو من قِبَل بالغٍ يملك إذناً صريحاً من الوصيّ.',
  ],
  termsSection5Title: '٥. صور الأطفال والمحتوى الذي ترفعه',
  termsSection5Intro: 'هذا القسم جوهري لأن خدمتنا تعتمد على صور يرفعها الأهل لأطفالهم. يُرجى قراءته بعناية:',
  termsSection5Items: [
    'الإذن: يحقّ لك رفع صورة طفل فقط إذا كنت والده أو وصيّه القانوني، أو إذا حصلت على إذن صريح ومسبق من الوصيّ القانوني للطفل.',
    'الإقرار والضمان: بقيامك برفع أي صورة أو محتوى، فإنك تُقرّ وتضمن أنك تملك كامل الحقوق والصلاحيات اللازمة لرفعه واستخدامه على النحو الموضّح في هذه الشروط.',
    'الغرض الوحيد: نستخدم صور الطفل والمعلومات المُرفقة حصراً لإنشاء رسومات القصة الخاصة بذلك الطفل، ولا نستخدمها لأي غرض آخر.',
    'لا تدريب للنماذج: لا نستخدم صور الأطفال أو محتواك لتدريب نماذج الذكاء الاصطناعي.',
    'لا بيع ولا تسويق: لا نبيع صور الأطفال ولا نشاركها مع أي طرف ثالث لأغراض تسويقية أو إعلانية.',
    'المعالجة بالذكاء الاصطناعي: لإنشاء الرسومات، قد تُرسَل الصور والمعلومات إلى مزوّدي خدمات ذكاء اصطناعي خارجيين موثوقين، وذلك حصراً بغرض إنتاج قصتك ووفق اتفاقيات تُقيّد استخدامهم للبيانات لهذا الغرض.',
    'الحذف من قواعد بياناتنا: بعد اكتمال إنشاء القصة وتسليم الطلب، نحذف صور الأطفال الأصلية المرفوعة من قواعد بياناتنا خلال مدة لا تتجاوز ٩٠ يوماً كحدٍّ أقصى. ويمكنك في أي وقت طلب حذف الصور فوراً عبر التواصل معنا.',
    'القصة النهائية: الرسومات المُولَّدة التي تشكّل قصتك تبقى محفوظة كجزء من طلبك ومنتَجك، أما الصور الأصلية للطفل فتُحذف وفق ما ذُكر أعلاه.',
  ],
  termsSection6Title: '٦. الطبيعة العلاجية للمحتوى وإخلاء المسؤولية الطبية',
  termsSection6Items: [
    'القصص الموصوفة بأنها «علاجية» هي قصص داعمة وتربوية تهدف إلى مساعدة الطفل على التعبير عن مشاعره ومواجهة تحدّياته بأسلوب لطيف.',
    'هذه القصص ليست تشخيصاً ولا علاجاً طبياً أو نفسياً، ولا تُغني عن استشارة طبيب أو أخصائي نفسي أو تربوي مؤهَّل.',
    'إذا كان طفلك يعاني ضائقة نفسية أو سلوكية جدّية، فيُرجى طلب المساعدة من مختصّ. لا تتحمّل المنصّة أي مسؤولية عن قرارات تُتّخذ بالاستناد إلى محتوى القصص.',
  ],
  termsSection7Title: '٧. الملكية الفكرية والترخيص',
  termsSection7Items: [
    'جميع حقوق المنصّة وتصاميمها وقوالبها وأسلوبها الفنّي وبرمجياتها مملوكة لنا أو لمرخّصينا.',
    'تمنحك المنصّة، عند إتمام الدفع، ترخيصاً شخصياً غير حصري وغير قابل للتحويل لاستخدام القصة المُنشأة لأغراض شخصية وعائلية غير تجارية.',
    'لا يجوز إعادة بيع القصة أو استخدامها تجارياً أو توزيعها على نطاق واسع دون إذن خطّي منّا.',
    'تمنحنا، بالقدر اللازم لتقديم الخدمة، ترخيصاً محدوداً لمعالجة المحتوى الذي ترفعه لإنشاء قصتك.',
  ],
  termsSection8Title: '٨. الأسعار والدفع',
  termsSection8Items: [
    'تُعرض الأسعار بالشيكل الإسرائيلي الجديد (₪)، ويُوضَّح عند الدفع ما إذا كانت شاملة للضرائب.',
    'تتمّ المدفوعات عبر مزوّدي خدمات دفع خارجيين، ولا نخزّن بيانات بطاقتك الكاملة على خوادمنا.',
    'نحتفظ بحقّ تعديل الأسعار في أي وقت، على ألا يؤثّر ذلك على الطلبات المؤكَّدة مسبقاً.',
  ],
  termsSection9Title: '٩. الطلبات والإنتاج والشحن',
  termsSection9Items: [
    'بعد الدفع واعتماد القصة، نبدأ بإنتاجها (وطباعتها إن كان الطلب لنسخة مطبوعة).',
    'تُشحَن النسخ المطبوعة إلى العنوان الذي تزوّدنا به داخل إسرائيل؛ وأنت مسؤول عن دقّة بيانات العنوان.',
    'قد تختلف مدد الإنتاج والتسليم؛ ونبذل جهداً معقولاً للالتزام بالمواعيد المُعلنة.',
  ],
  termsSection11Title: '١١. الاستخدام المقبول والمحتوى المحظور',
  termsSection11Items: [
    'يُحظر رفع صور أو محتوى لا تملك الحقوق أو الإذن اللازم لرفعه.',
    'يُحظر رفع صور أطفال لست والدهم أو وصيّهم القانوني، ودون إذن صريح من الوصيّ.',
    'يُحظر رفع محتوى مخالف للقانون أو مُسيء أو يحضّ على الكراهية أو ينتهك حقوق الغير.',
    'نحتفظ بحقّ رفض أو إزالة أي محتوى مخالف وإيقاف الحسابات المخالفة.',
  ],
  termsSection12Title: '١٢. الخصوصية وحماية البيانات',
  termsSection12Intro: 'نلتزم بحماية خصوصيتك ومعالجة بياناتك وفق قانون حماية الخصوصية الإسرائيلي لعام ١٩٨١ (חוק הגנת הפרטיות) والأنظمة الصادرة بموجبه.',
  termsSection12Items: [
    'البيانات التي نجمعها: بيانات الحساب (الاسم، البريد الإلكتروني، رقم الهاتف)، وتفاصيل الطلب وعنوان الشحن، والمعلومات التي تُدخلها لإنشاء القصة (بما فيها اسم الطفل وعمره وصوره والتفاصيل التي تقدّمها)، وبيانات الدفع التي يعالجها مزوّد الدفع.',
    'أغراض المعالجة: تقديم الخدمة وإنشاء القصة، ومعالجة الطلبات والمدفوعات والشحن، والتواصل معك بشأن طلبك، والامتثال للالتزامات القانونية.',
    'مشاركة البيانات: نشارك القدر الضروري فقط مع مزوّدي خدمات الذكاء الاصطناعي (لإنشاء الرسومات)، ومزوّدي الدفع، وشركات الشحن، ومزوّدي الاستضافة، وذلك حصراً لتقديم الخدمة.',
    'النقل خارج إسرائيل: قد تُعالَج بعض البيانات لدى مزوّدي خدمات خارج إسرائيل؛ ونتّخذ خطوات معقولة لحماية البيانات عند نقلها.',
    'الاحتفاظ والحذف: نحتفظ بالبيانات للمدة اللازمة لتقديم الخدمة والوفاء بالالتزامات القانونية والمحاسبية. وتُحذف صور الأطفال الأصلية وفق ما ورد في القسم الخاص بصور الأطفال أعلاه.',
    'الأمن: نتّخذ تدابير تقنية وتنظيمية معقولة لحماية بياناتك من الوصول أو الاستخدام غير المصرَّح به.',
    'حقوقك: يحقّ لك الاطّلاع على بياناتك الشخصية وتصحيحها وطلب حذفها، وذلك بمراسلتنا على البريد الإلكتروني الموضّح أدناه.',
  ],
  termsSection13Title: '١٣. ملفات تعريف الارتباط (Cookies)',
  termsSection13P1: 'نستخدم ملفات تعريف الارتباط والتقنيات المماثلة لتشغيل المنصّة وتحسين تجربتك وتحليل الاستخدام. يمكنك التحكّم بها عبر إعدادات متصفّحك.',
  termsSection14Title: '١٤. إخلاء الضمانات',
  termsSection14P1: 'تُقدَّم الخدمة «كما هي» و«حسب توافرها» دون ضمانات صريحة أو ضمنية بأي شكل يتجاوز ما يفرضه القانون المعمول به.',
  termsSection15Title: '١٥. حدود المسؤولية',
  termsSection15P1: 'إلى الحدّ الذي يسمح به القانون، لا تتجاوز مسؤوليتنا الإجمالية تجاهك المبلغ الذي دفعته فعلياً مقابل الطلب محلّ النزاع، ولا نتحمّل أي أضرار غير مباشرة أو تبعية.',
  termsSection16Title: '١٦. التعويض',
  termsSection16P1: 'توافق على تعويضنا عن أي مطالبات أو أضرار تنشأ عن مخالفتك لهذه الشروط، أو عن رفعك محتوى أو صوراً دون امتلاك الحقوق أو الأذونات اللازمة (وخاصة صور الأطفال دون إذن الوصيّ القانوني).',
  termsSection17Title: '١٧. تعديل الشروط',
  termsSection17P1: 'يجوز لنا تحديث هذه الشروط من وقتٍ لآخر. نَنشر النسخة المحدَّثة على هذه الصفحة مع تحديث تاريخ «آخر تحديث»، ويُعدّ استمرارك في استخدام المنصّة بعد ذلك قبولاً للنسخة المعدَّلة.',
  termsSection18Title: '١٨. القانون الحاكم والاختصاص القضائي',
  termsSection18P1: 'تخضع هذه الشروط لقوانين دولة إسرائيل وتُفسَّر وفقاً لها، وتختصّ المحاكم المختصّة في {jurisdictionCity}، إسرائيل، بالنظر في أي نزاع ينشأ عنها.',
  termsSection19Title: '١٩. التواصل',
  termsSection19Intro: 'لأي استفسار، أو لطلب الاطّلاع على بياناتك أو تصحيحها أو حذفها، تواصل معنا عبر:',
  termsContactEmail: 'البريد الإلكتروني',
  termsContactWhatsApp: 'واتساب',

  // Therapeutic approach page
  therapeuticPageTitle: 'المحتوى العلاجي: كيف نساعد طفلك على تخطّي تحدياته',
  therapeuticLede: 'في «أنا البطل» نؤمن أن القصة ليست تسليةً فحسب، بل أداةٌ لطيفة تساعد الطفل على فهم مشاعره ومواجهة مخاوفه. نستند في كتابة قصصنا إلى مبادئ «العلاج بالقصة» (المعروف عالمياً باسم Bibliotherapy)، وهو أسلوبٌ يعتمده المربّون والمختصّون منذ عقود لمساعدة الأطفال على تجاوز تحدياتهم من خلال شخصيةٍ يحبّونها ويرون أنفسهم فيها.',
  therapeuticPrinciplesTitle: 'نُكيّف كل قصة على عمر طفلك وهدفه',
  therapeuticPrinciplesIntro: 'لكل طفلٍ عمره، ولكل تحدٍّ هدفه. لذلك لا نكتب قصةً واحدة تصلح للجميع، بل نصمّم كل قصة حول أربعة مبادئ:',
  therapeuticPillar1Title: 'عمر طفلك',
  therapeuticPillar1Text: 'نختار اللغة والمشاهد والوتيرة لتناسب مرحلة طفلك العمرية — فما يطمئن طفلاً في الثالثة يختلف عمّا يلهم طفلاً في التاسعة.',
  therapeuticPillar2Title: 'هدف القصة',
  therapeuticPillar2Text: 'ننطلق من خطوة صغيرة وواقعية تتمنّاها لطفلك — أن ينام وحده، أو أن يودّعك دون بكاء — لا من وعظٍ أو تأنيب.',
  therapeuticPillar3Title: 'التماهي',
  therapeuticPillar3Text: 'يكون طفلك هو بطل القصة، فيرى نفسه فيها ويعيش الحلّ مع البطل خطوةً بخطوة.',
  therapeuticPillar4Title: 'نهاية آمنة',
  therapeuticPillar4Text: 'تنتهي كل قصة بالأمل والطمأنينة، فيُغلق طفلك الكتاب وهو يشعر بالأمان والقدرة على المواجهة.',
  therapeuticPrinciplesNote: 'تستند هذه المبادئ إلى أدبيات «العلاج بالقصة» وأبحاث علم نفس الطفل ومراحل نموّه المعرفي والعاطفي، وإلى مقارباتٍ تربوية قائمة على الأدلة في ملاءمة المحتوى لكل مرحلة عمرية. أمّا كيفية ترجمة هذه الأسس إلى قصةٍ بعينها فهي خلاصة منهجيتنا الخاصة — وما يهمّك أن النتيجة قصةٌ مصمَّمة لطفلك وحده، بعمره، وباسمه، وبالتحدّي الذي يمرّ به.',
  therapeuticScienceTitle: 'لماذا تنفع القصص؟ ما يقوله العلم',
  therapeuticScienceIntro: 'حين يقرأ الطفل قصةً قريبة من حاله، يحدث في داخله ثلاثة أمورٍ لطيفة يصفها المختصّون في العلاج بالقصة:',
  therapeuticScienceIdentification: 'التماهي: يجد الطفل نفسه في البطل، فيشعر أنه ليس وحده في ما يمرّ به.',
  therapeuticScienceCatharsis: 'التنفيس: يعبّر عن مشاعره المكبوتة من خلال أحداث القصة، في مساحةٍ آمنة.',
  therapeuticScienceInsight: 'الاستبصار: يكتشف طريقاً للتعامل مع مشكلته دون أن يشعر أنه يُلقَّن أو يُؤنَّب.',
  therapeuticScienceSourcesIntro: 'هذه المبادئ ليست رأياً، بل موضوع مقالاتٍ وأبحاثٍ تربوية ونفسية. إليك مصادر عربية يمكنك قراءتها لتعرف أكثر:',
  therapeuticResearch1Title: 'علاج بالقراءة (Bibliotherapy)',
  therapeuticResearch1Source: 'ويكيبيديا',
  therapeuticResearch1Summary: 'مدخل تعريفي للعلاج بالقراءة بوصفه استخدام موادّ قرائية مختارة وسيلةً علاجية، مع لمحة عن تاريخه وأنواعه وتطبيقاته النفسية.',
  therapeuticResearch2Title: 'التدعيم العاطفي بالقصّة',
  therapeuticResearch2Source: 'أكاديمية القاسمي',
  therapeuticResearch2Summary: 'برنامج أكاديمي يدرّب المربّين على استخدام القصة وسيطاً علاجياً يساعد الأطفال على التعبير عن مشاعرهم.',
  therapeuticResearch3Title: 'القصة العلاجية ومراحل الشفاء',
  therapeuticResearch3Source: 'العلاج بالقصة',
  therapeuticResearch3Summary: 'شرحٌ لعناصر القصة العلاجية وأهدافها ومراحلها الأربع: التعاطف، ثم التأمّل، ثم التنفيس، ثم الوعي.',
  therapeuticResearch4Title: 'الببليوثيرابيا أو العلاج بالقراءة',
  therapeuticResearch4Source: 'آرت ثيرابي — الكويت',
  therapeuticResearch4Summary: 'مقالٌ يعرّف العلاج بالقراءة الموجَّهة وأثره العاطفي، مع لمحة تاريخية عن نشأته واستخداماته.',
  therapeuticDisclaimer: 'قصصنا العلاجية قصصٌ داعمة وتربوية تساعد طفلك على التعبير عن مشاعره ومواجهة تحدياته بلطف. لكنها ليست تشخيصاً ولا علاجاً طبياً أو نفسياً، ولا تغني عن استشارة طبيبٍ أو أخصائيٍّ مؤهَّل عند الحاجة.',
  therapeuticCtaTitle: 'ابدأ الآن: قصصٌ علاجية جاهزة لطفلك',
  therapeuticCtaIntro: 'هذه بعض القصص العلاجية الجاهزة — اختر التحدّي الأقرب لطفلك وابدأ بإنشاء قصته الخاصة:',
  therapeuticCtaBtn: 'تصفّح كل القصص العلاجية',

  // Admin Stats page
  adminBannerGradSeries: 'بانر سلسلة تخرّج الروضة',
  adminBannerPromo: 'بانر العرض',
  adminRangeToday: 'اليوم',
  adminRange7Days: '٧ أيام',
  adminRange30Days: '٣٠ يوم',
  adminRange90Days: '٩٠ يوم',
  adminRangeAll: 'كل الوقت',
  adminRangeCustom: 'مخصص',
  adminExpenseAds: 'إعلانات',
  adminExpenseAi: 'ذكاء اصطناعي',
  adminExpensePrinting: 'طباعة',
  adminExpenseDelivery: 'توصيل',
  adminExpenseOther: 'أخرى',
  adminFrom: 'من',
  adminTo: 'إلى',
  adminSelectDateRange: 'اختر تاريخ البداية والنهاية',
  adminConversionFunnel: 'مسار التحويل',
  adminVisitors: 'زوّار',
  adminPreviews: 'معاينات',
  adminPurchases: 'مشتريات',
  adminOverallConversion: 'التحويل الكلي من زائر إلى عملية شراء:',
  adminBannerClicks: 'نقرات البانرات:',
  adminUniqueVisitor: 'زائر مختلف',
  adminOfVisitors: 'من الزوّار',
  adminVisitor: 'زائر',
  adminFinancialPerformance: 'الأداء المالي',
  adminRevenueLabel: 'الإيرادات',
  adminCogsCost: 'تكلفة المنتجات (طباعة+توصيل+ذكاء)',
  adminExpensesAds: 'مصاريف (إعلانات…)',
  adminNetProfit: 'صافي الربح',
  adminProfitMargin: 'هامش الربح',
  adminAiSpendActual: 'إنفاق الذكاء الفعلي (مرجعي)',
  adminDailyIncomeSpend: 'الدخل والإنفاق اليومي',
  adminDayTooltipIncome: 'دخل',
  adminDayTooltipSpend: 'إنفاق',
  adminDayTooltipProfit: 'ربح',
  adminLegendIncome: 'الدخل',
  adminLegendSpend: 'الإنفاق',
  adminCostRates: 'معدلات التكلفة',
  adminBookPrinting: 'طباعة الكتاب (₪)',
  adminDeliveryCost: 'التوصيل (₪)',
  adminExchangeRate: 'سعر صرف الدولار',
  adminSaveRates: 'حفظ المعدلات',
  adminSaved: 'تم الحفظ',
  adminAiCostNote: 'تُحتسب تكلفة الذكاء الاصطناعي من الإنفاق الفعلي لكل قصة (بالدولار) مضروباً بسعر الصرف.',
  adminExpenses: 'المصاريف',
  adminDescription: 'الوصف',
  adminDescriptionPlaceholder: 'مثال: حملة فيسبوك أيلول',
  adminType: 'النوع',
  adminAmount: 'المبلغ (₪)',
  adminPeriod: 'الفترة',
  adminPeriodSpread: 'فترة (يُوزّع يومياً)',
  adminOneTime: 'مرة واحدة',
  adminDate: 'التاريخ',
  adminAdd: 'إضافة',
  adminAmountCol: 'المبلغ',
  adminNoExpensesYet: 'لا توجد مصاريف بعد',
  adminEmailTracking: 'تتبع الإيميلات',
  adminEmailTypeOrderConfirmation: 'تأكيد طلب',
  adminEmailTypeStoryReady: 'القصة جاهزة',
  adminEmailTypeStoryPdf: 'تسليم PDF',
  adminEmailTypeBookReady: 'الكتاب جاهز',
  adminEmailTypeTeaser: 'تذكير معاينة',
  adminEmailTypeStoryFinalize: 'مراجعة واعتماد',
  adminEmailTypeAccountCreated: 'حساب جديد',
  adminEmailTypeMagicLogin: 'رابط دخول',
  adminEmailTypePasswordReset: 'استعادة كلمة مرور',
  adminEmailTypePaymentNotice: 'إشعار دفع (داخلي)',
  adminEmailTypeUnknown: 'أخرى',
  adminEmailFilterAll: 'الكل',
  adminEmailFilterOpened: 'مفتوحة',
  adminEmailFilterNotOpened: 'لم تُفتح',
  adminStatus: 'الحالة',
  adminEmailCount: 'إيميل',
  adminRecipient: 'المستلم',
  adminSubject: 'الموضوع',
  adminSent: 'أُرسل',
  adminOpenedQuestion: 'فُتح؟',
  adminOpenTime: 'وقت الفتح',
  adminOpenCount: 'مرات',
  adminYes: 'نعم',
  adminNo: 'لا',
  adminNoEmailsYet: 'لا توجد إيميلات مسجّلة بعد',
  adminTopViewedStories: 'الأكثر مشاهدة (القصص)',
  adminTopPreviewed: 'الأكثر معاينة',
  adminTopViewedCategories: 'الأكثر مشاهدة (التصنيفات)',
  adminViewCount: 'مشاهدة',
  adminPreviewCount: 'معاينة',
  adminName: 'الاسم',
  adminNoDataYet: 'لا توجد بيانات',
  adminDashboardLink: 'لوحة التحكم',
  adminDeleteExpense: 'حذف',
  adminPaymentNoticeShort: 'إشعار دفع',

  // Series Wizard
  adminCreateSeries: 'إنشاء سلسلة',
  adminFromStory: 'من القصة: ',
  adminStepStory: 'القصة',
  adminStepGraphics: 'الرسومات',
  adminStepCount: 'العدد',
  adminStepChildren: 'الأطفال (اختياري)',
  adminStoryText: 'القصة (النص)',
  adminSameStory: 'نفس القصة',
  adminSameStoryDesc: 'نفس النص تمامًا، مع تبديل الاسم وملاءمة صيغة المذكّر/المؤنّث لكل طفل.',
  adminNewStoryPerChild: 'قصة جديدة لكل طفل',
  adminNewStoryPerChildDesc: 'نفس القالب والفكرة، لكن يكتب الذكاء الاصطناعي نصًّا جديدًا لكل طفل.',
  adminGraphicsLabel: 'الرسومات',
  adminSameGraphicsLabel: 'نفس الرسومات',
  adminSameGraphicsDesc: 'نفس الصور تمامًا مع تبديل وجه الطفل — نثبّت صورة القصة الأصلية كمرجع ونطلب من النموذج إعادة إنتاجها بنفس التكوين.',
  adminNewGraphics: 'رسومات جديدة',
  adminNewGraphicsDesc: 'نولّد صورًا جديدة لكل طفل اعتمادًا على النص، مع الحفاظ على النمط.',
  adminWizardSettings: 'الإعدادات',
  adminChildrenCount: 'عدد الأطفال',
  adminSeriesTitleField: 'عنوان السلسلة',
  adminSeriesTitlePlaceholder: 'مثلاً: روضة الأمل - الفوج أ',
  adminDefaultPricePerBook: 'السعر الافتراضي لكل كتاب (₪)',
  adminDefaultPricePlaceholder: 'مثلاً 200',
  adminTestSeries: 'سلسلة تجريبية (لا تُحتسب في الإحصائيات)',
  adminChildrenOptionalTitle: 'الأطفال (اختياري)',
  adminChildrenPrefillHelp: 'يمكنك تعبئة الأسماء الآن أو لاحقًا. الصور والأسعار والتوليد تتم في صفحة إدارة السلسلة بعد الإنشاء.',
  adminChildNameOptional: 'اسم الطفل (اختياري)',
  adminCreateSeriesAndManage: 'إنشاء السلسلة وإدارتها',
  adminCreatingSeries: 'جارِ الإنشاء…',
  adminBaseStoryNotSet: 'لم يتم تحديد القصة الأساسية',
  adminLoadStoryError: 'تعذّر تحميل القصة',
  adminCreateSeriesError: 'تعذّر إنشاء السلسلة',
  adminLoading: 'جارِ التحميل…',

  // Language switcher
  langAr: 'عربي',
  langHe: 'עברית',

  // Pay-first experiment — admin settings
  adminPayFirstTitle: 'تجربة الدفع المسبق (A/B)',
  adminPayFirstHelp: 'عند التفعيل، تُوجَّه نسبة من الزوّار إلى مسار "الدفع أولاً": يضيفون الكتب إلى السلة ويدفعون قبل إنشاء المعاينة، ثم ينشئون القصص من حسابهم بعد الدفع ويطلبون منّا تنقيحها للطباعة. تبقى بقية الزوّار على مسار المعاينة المجانية.',
  adminPayFirstPercent: 'نسبة الزوّار في مسار الدفع المسبق (%)',

  // Pay-first experiment — storefront add-to-cart
  payFirstAddToCart: 'أضِف إلى السلة',
  payFirstAddAnother: 'أضِف نسخة أخرى',
  payFirstAddedNote: 'تمت الإضافة إلى السلة',
  payFirstAddedModalTitle: 'أُضيف الكتاب إلى السلة',
  payFirstCtaNote: 'تشترون الكتاب الآن — وبعد الدفع تُنشئون قصته بإسم طفلكم وصورته، ولا نطبع إلا بعد موافقتكم.',
  pfProofIgCaption: 'أهالٍ سعداء من صفحتنا على إنستغرام — ابحثوا عنّا بهاتفكم:',
  payFirstAddedModalSubtitle: 'الكتاب في سلتك للشراء. أتمّ الدفع الآن أو أضف كتباً أخرى — وبعد الدفع تُنشئ القصة بإسم طفلك وصورته.',
  payFirstModalCheckout: 'إتمام الدفع الآن',
  payFirstModalKeepShopping: 'إضافة كتب أخرى',
  payFirstGoToCart: 'إلى السلة',

  // Pay-first experiment — cart + checkout + success
  payFirstCartHint: 'ادفع ثمن كتبك أولاً، ثم أنشئ قصة كل كتاب من حسابك واطلب منّا تنقيحها قبل الطباعة.',
  payFirstDeliveryNote: 'تُضاف رسوم التوصيل للكتب المطبوعة عند الدفع.',
  payFirstReassurance: 'بعد الدفع تُنشئ قصصك بنفسك خطوة بخطوة من حسابك، ثم يراجعها فريقنا ويُتقنها ويجهّزها للطباعة — ولا نطبعها إلا بعد اعتمادك للنسخة النهائية.',
  payFirstPayAll: 'ادفع ثمن الكل',
  payFirstCheckoutHint: 'بعد الدفع، أنشئ قصة كل كتاب من حسابك.',
  payFirstSuccessDesc: 'تم استلام دفعتك. اذهب إلى طلبك لإنشاء قصصك الآن.',
  payFirstCreateNow: 'أنشئ قصصي',

  // Pay-first experiment — order page + post-payment creation
  payFirstOrderCreateTitle: 'أنشئ قصصك',
  payFirstOrderCreateHint: 'لكل كتاب دفعت ثمنه، أنشئ القصة بتفاصيل طفلك وصوره، ثم اطلب منّا تنقيحها لإتمامها للطباعة.',
  payFirstCreateStoryCta: 'أنشئ قصتك',
  payFirstStoryCreatedCta: 'اعرض / عدّل قصتك',
  payFirstStoryGenerating: 'جارٍ الإنشاء…',
  payFirstOrderItemCreateTitle: 'أنشئ قصتك',
  payFirstOrderItemCreateSubtitle: 'لقد دفعت ثمن هذا الكتاب. أدخل تفاصيل طفلك وصوره لإنشاء القصة، ثم اطلب منّا تنقيحها قبل الطباعة.',

  // Pay-first experiment — request edits
  requestEditsTitle: 'اطلب منّا تعديلات قبل الطباعة',
  requestEditsPlaceholder: 'اكتب التعديلات التي تريدها على القصة أو الصور…',
  requestEditsSubmit: 'اطلب منّا التعديل',
  requestEditsSending: 'جارٍ الإرسال…',
  requestEditsSent: 'تم الإرسال — سنعمل على تنقيحها ونرسل لك النسخة النهائية لاعتمادها قبل الطباعة.',
  requestEditsEmpty: 'يرجى كتابة التعديلات المطلوبة',
};

export default ar;
